import React, { Component } from "react";
// import './style.scss';
import {
  InputSearch,
  NormalModal,
  NormalButton,
  NormalButtonCart,
  Pagination,
  NormalSelect,
  NormalInput,
  NormalCheckbox,
  SearchInputKeyboard,
  NormalRadio,
  TableWrapper,
  NormalMultiSelect,
  NormalTextarea,
} from "component/common";
// import { dateFormat } from 'service/helperFunctions';
import _ from "lodash";
import { history } from "helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  commonCreateApi,
  commonUpdateApi,
  updateDiscount,
} from "redux/actions/common";
import SimpleReactValidator from "simple-react-validator";
import img from "assets/images/service1.png";
import { dateFormat } from "service/helperFunctions";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";
import { withTranslation } from "react-i18next";
import { debounce } from "service/Helper";
import { IoSearchCircle } from "react-icons/io5";
import back from "../../../../assets/images/back.png";
import { InputKeyboard } from "component/common/InputKeyboard";
import { NumPadKeyboard } from "component/common/NumPadKeyboard";
import { array } from "prop-types";
//import { isMobile } from "react-device-detect";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import ReactDOM from "react-dom";
// Instead of the default import, you can also use this:
// import { KeyboardReact as Keyboard } from "react-simple-keyboard";
import { AiOutlineSearch } from "react-icons/ai";
import { duration } from "moment";
//import { C } from "@fullcalendar/core/internal-common";
import { OpenPackage } from "./openPackage"; // Open Package

var bgcolors = [
  "#e6cbd4", //favourite & search
  "#d6f7d6", //service
  "#b7e4ef", //Retail0
  "#777bdc80", //package
  "#ecc8f3", //prepaid
  "#8c6fd09c", //voucher
];

let deviceWidth = window.innerWidth;

const getAllNestedMenu = (menuList) => {
  let child = [];
  const flattenMenu = menuList.map((m) => {
    if (m.child && m.child.length) {
      child = [...child, ...m.child];
    }
    return m;
  });

  return flattenMenu.concat(child.length ? getAllNestedMenu(child) : child);
};

// // conditionList
// const conditionList = [
//   {
//     id: 1,
//     type: "Inclusive",
//     conditionType1: "Service Only",
//     conditionType2: "Facial",
//     amount: 500,
//     rate: "Amount$",
//   },
// ];

export class TreatmentClass extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      activeTab: "treatment",
      formFields: {
        search: "",
      },
      menuItems: [
        { to: "/admin/catalog", label: "Favorites", id: "Favorites" },
        { to: "/admin/catalog", label: "SERVICE", id: "SERVICE" },
        { to: "/admin/catalog", label: "Package", id: "PACKAGE" },
        { to: "/admin/catalog", label: "Prepaid", id: "PREPAID" },
        { to: "/admin/catalog", label: "Voucher", id: "VOUCHER" },
        { to: "/admin/catalog", label: "Retail", id: "RETAIL" },
      ],
      //activeMenu: "SERVICE",
      newMenu: false,
      activeMenu: "",
      menuId: "",
      itemList: [],
      page: 1,
      rangeId: "",
      rangeName: "",
      rangeOption: [],
      activeMenuName: "Face",
      serviceName: "",
      serviceDetail: "",
      serviceDet: "",
      isCoursePopupId: "",
      formQty: 1,
      formHoldQty: 0,
      holdCheckbox: false,
      focCheckbox: false,
      holdReasonList: [],
      focReasonList: [],
      holdSelectedReason: "",
      focSelectedReason: "",
      bgcolor: "",
      itemDescription: [],
      limit: 18,
      //search_serial_no: "",
      menuData: [],
      prevMenus: [],
      currentMenus: [],
      activeLevel: 0,
      isLoading: false,
      paginationItemList: {},
      menuListOriginalData: [],
      keyboardVisibility: false,
      keyboardToogleStatus: false,
      prepaidModal: false,
      serial_no: "",
      isOpenDuration: false,
      hours: null,
      minutes: null,
      total: null,
      pricePerHour: 0,
      totalHours: null,
      isDurationProduct: false,
      treatmentCartId: null,
      isTcm: false,
      injuries: [],
      injuryOptions: [
        {
          label: "肩",
          value: "肩",
        },
        {
          label: "颈",
          value: "颈",
        },
        {
          label: "背",
          value: "背",
        },
        {
          label: "腰",
          value: "腰",
        },
        {
          label: "手",
          value: "手",
        },
        {
          label: "脚",
          value: "脚",
        },
        {
          label: "膝盖",
          value: "膝盖",
        },
        {
          label: "骨盆",
          value: "骨盆",
        },
      ],
      otherInjury: "",
      injuryPeriod: "",
      symptom: "",
      tcmId: null,
      isVoucherActive: false,
      physicianOptions: [],
      physician: "",
      voucherQuantity: "",
      newVoucherData: [],
      previousVoucher: {},
      totalActiveVouchers: 0,
      totalVoucherAmount: 0,
      voucherNumbers: "",
      headerDetails: [
        {
          label: "Voucher No",
        },
        {
          label: "Name",
        },
        {
          label: "Value",
        },
        {
          label: "Exp Date",
        },
        {
          label: "Allow Discount",
        },
      ],

      isOpenPackagePopup: false, // Open Package
      packageData: {}, // Open Package
    };

    // this.handleClickOutside = this.handleClickOutside.bind(this);
    // this.clickHanlder = this.clickHanlder.bind(this);
  }

  componentDidMount = async () => {
    // this.getCart()

    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });
    let { menuItems } = this.state;
    let { selectedCart } = this.props;
    // this.props.getCommonApi('catalogitemdept/').then((res) => {
    //     menuItems = res.data;
    //     this.setState({ menuItems })
    // })
    // this.getRange();
    // this.getItemList({});
    this.props.getCommonApi("displaycatalog/view/").then((res) => {
      menuItems = res.data;
      this.setState({ menuData: menuItems });
      this.setCurrentMenuSet(menuItems);
    });
    // console.log(this.props.basicApptDetail, "baseapptdataprops");
    if (selectedCart) {
      // if (this.props.tokenDetails?.retailbatchsno) {

      //   obj.batch_sno = serial_no;
      // }
      this.setState({
        activeTab: "treatmentDetail",
        serviceDetail: selectedCart,
        serviceName: selectedCart.item_desc,
        activeMenu: selectedCart.selected_menu,
        activeMenuName: selectedCart.selected_menu,
      });
    } else {
      console.log(selectedCart, "asgdfhfrtyrdfg else");
    }
    this.getMenus();
    this.getItemList({});
    this.getDropdownData();
    // document.addEventListener("click", this.handleClickOutside, true);
  };

  // componentWillUnmount() {
  //   document.addEventListener("click", this.handleClickOutside, true);
  // }

  // // handleClickOutside
  // handleClickOutside = (event) => {
  //   const domNode = ReactDOM.findDOMNode(this);
  //   if (!domNode || !domNode.contains(event.target)) {
  //     this.setState({ keyboardVisibility: false, keyboardToogleStatus: false });
  //   }
  // };

  // set prev menu common event
  setPrevMenuSet = async (data) => {
    await this.setState({ prevMenus: data });
  };

  // set current menu common event
  setCurrentMenuSet = async (data) => {
    //sort Data
    let sorData = data.sort((a, b) => (a?.seqnumber > b?.seqnumber ? 1 : -1));

    await this.setState({ menuListOriginalData: sorData });

    var limitFixed = 8;
    var currentPageValue = 1;
    var metaObj = {
      per_page: limitFixed,
      current_page: currentPageValue,
      total: sorData.length,
      total_pages: Math.ceil(sorData.length / limitFixed),
    };
    this.setState({ paginationItemList: metaObj });
    let sliceData = sorData.slice(
      currentPageValue * limitFixed - limitFixed,
      currentPageValue * limitFixed
    );
    // debugger;
    await this.setState({
      currentMenus: sliceData,
      activeMenu: sorData[0]?.menuCode,
    });
    await this.getItemList({});
  };

  getDropdownData = () => {
    let { focReasonList, holdReasonList } = this.state;
    this.props.getCommonApi(`focreason/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          focReasonList.push({
            value: value.id,
            label: value.foc_reason_ldesc,
          });
        }
        this.setState({ focReasonList });
      }
    });
    this.props.getCommonApi(`holditemsetup/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          holdReasonList.push({
            value: value.id,
            label: value.hold_desc,
          });
        }
        this.setState({ holdReasonList });
      }
    });
  };
  getMenus = () => {
    let { menuOption, activeMenu } = this.state;
    menuOption = [];

    this.props
      .getCommonApi(`catalogitemdept/?Item_Dept=${activeMenu}`)
      .then((res) => {
        // activeMenu = []

        for (let key of res.data) {
          menuOption.push({
            value: key.id,
            label: key.itm_desc,
            code: key.itm_code,
            seq: key.itm_seq,
            durationProduct: key?.is_duration_product,
          });
        }
        this.setState({ menuOption });
      });
  };

  // componentDidUpdate(prevProps, newProps) {
  //     let {  selectedCart } = this.state;
  //     // console.log(selectedCart, "asgdfhfrtyrdfg", prevProps, newProps)
  //     if( selectedCart){

  //         this.setState({activeTab: "treatmentDetail", serviceDetail:selectedCart});
  //     } else {

  //         // console.log(selectedCart, "asgdfhfrtyrdfg else")
  //     }
  // }

  getRange = () => {
    let { rangeOption, activeMenu, menuId } = this.state;
    rangeOption = [];
    if (activeMenu !== "Favorites") {
      this.props
        .getCommonApi(
          `catalogitemrange/?Item_Deptid=${menuId}&type=${activeMenu}`
        )
        .then((res) => {
          // activeMenu = []
          for (let key of res.data) {
            rangeOption.push({ value: key.id, label: key.itm_desc });
          }
          this.setState({ rangeOption });
        });
    }
  };

  componentDidUpdate(prevProps, nextProps) {}

  // handleSearch = async (event) => {
  //   event.persist();
  //   let { formFields } = this.state;
  //   formFields["search"] = event.target.value;
  //   await this.setState({ formFields, activeMenu: 8, page: 1 });
  //   let debounceProductSearch = debounce(this.getItemList, 100);
  //   let searchString = event?.target?.value;
  //   let data = { search: searchString };
  //   debounceProductSearch(data);
  // };

  getItemList = (query) => {
    let { itemList, activeMenu, rangeId, menuId, limit, isDurationProduct } =
      this.state;

    let { page = this.state.page, search = this.state.formFields.search } =
      query;

    let limitValue = deviceWidth > 1280 ? 12 : 18;
    this.setState({ itemList: [], activeTab: "treatment" });
    if (activeMenu == "Favorites") {
      this.props
        .getCommonApi(`catalogfavorites/?page=${page}&limit=${limitValue}`)
        .then(async (res) => {
          itemList = res.data;

          await this.setState({ itemList, bgcolor: bgcolors[0] });
        });
    } else if (activeMenu == "SERVICE") {
      this.props
        .getCommonApi(
          `servicestock/?Item_Deptid=${menuId}&page=${page}&Item_Rangeid=${rangeId}&limit=${limitValue}`
        )
        .then(async (res) => {
          itemList = res.data;
          // if (isDurationProduct) {
          //   let { dataList = [] } = itemList;
          //   dataList.forEach((item) => {
          //     item.isDuration = true;
          //   });
          //   console.log(dataList, "dataList");
          // }
          await this.setState({ itemList, bgcolor: bgcolors[1] });
        });
    } else if (activeMenu == "RETAIL") {
      this.props
        .getCommonApi(
          `retailstock/?Item_Deptid=${menuId}&page=${page}&Item_Rangeid=${rangeId}`
        )
        .then(async (res) => {
          itemList = res.data;
          await this.setState({ itemList, bgcolor: bgcolors[2] });
        });
    } else if (activeMenu == "PACKAGE") {
      this.props
        .getCommonApi(
          `packagestock/?Item_Deptid=${menuId}&page=${page}&Item_Rangeid=${rangeId}&limit=${limitValue}`
        )
        .then(async (res) => {
          itemList = res.data;
          await this.setState({ itemList, bgcolor: bgcolors[3] });
        });
    } else if (activeMenu == "PREPAID") {
      this.props
        .getCommonApi(
          `prepaidstock/?Item_Deptid=${menuId}&page=${page}&Item_Rangeid=${rangeId}&limit=${limitValue}`
        )
        .then(async (res) => {
          itemList = res.data;
          await this.setState({ itemList, bgcolor: bgcolors[4] });
        });
    } else if (activeMenu == "VOUCHER") {
      this.props
        .getCommonApi(
          `voucherstock/?Item_Deptid=${menuId}&page=${page}&Item_Rangeid=${rangeId}&limit=${limitValue}`
        )
        .then(async (res) => {
          itemList = res.data;
          await this.setState({ itemList, bgcolor: bgcolors[5] });
        });
    } else if (activeMenu == "8") {
      // if (search == "" || (search && search.length >= 3)) {
      this.props
        .getCommonApi(`catalogsearch/?search=${search}&page=${page}`)
        .then(async (res) => {
          itemList = res.data;
          // let serialNum = res?.data?.dataList[0]?.uomprice[0].serial_no;
          // if (serialNum) {
          //   this.setState({
          //     search_serial_no: serialNum,
          //   });
          // }

          await this.setState({ itemList, bgcolor: bgcolors[0] });
        });
      // }
    } else {
      if (activeMenu) {
        try {
          this.props
            .getCommonApi(
              `displayItems/?menucode=${activeMenu}&search=${search}&page=${page}`
            )
            .then(async (res) => {
              let list = res.data;
              await this.setState({ itemList: list, bgcolor: bgcolors[0] });
            });
        } catch (e) {
          console.log("error", e);
        }
      }
    }
  };
  handlecheckIN = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleIconSearch();
    }
  };

  handleSearch = async (input) => {
    // event.persist();
    // this.handleToHideShowKeyboard();

    let { formFields, activeMenu } = this.state;
    formFields["search"] = input;
    // formFields["search"] = text;

    activeMenu = 8;
    await this.setState({ formFields, activeMenu, page: 1 });

    // if (!this.debouncedFn) {
    //   this.debouncedFn = _.debounce(() => {
    //     let searchString = formFields.search;
    //     let data = { search: searchString };
    //     this.getItemList(data);
    //   }, 500);
    // }
    // this.debouncedFn();
  };

  handleIconSearch = async () => {
    //this.handleClick();

    let { formFields } = this.state;
    let data = { search: formFields["search"] ?? "" };
    await this.getItemList(data);
    //this.child.handleToHideShowKeyboard();
    // this.setState({ keyboardVisibility: false, keyboardToogleStatus: false });
  };

  getDateTime = (data) => {
    let date = new Date(data);
    date = String(date).split(" ");
    let date1 = date[2] + "th " + date[1] + ", " + date[3];
    let time = date[4].split(":");
    let time1 =
      String(Number(time[0]) > 12 ? Number(time[0]) - 12 : time[0]) +
      ":" +
      time[1] +
      (Number(time[0]) > 12 ? "PM" : "AM");
    return time1 + ", " + date1;
  };

  handleSubmit = (data, index) => {
    let { itemDescription } = this.state;

    try {
      this.props
        .getCommonApi(`itemdescapiviewset/?stock_id=${data.id}`)
        .then((res) => {
          itemDescription = [];
          itemDescription = res.data;
          this.setState({ itemDescription });
        });
      this.setState({
        activeTab: "treatmentDetail",
        serviceName: data.item_desc,
        serviceDetail: data,
      });
    } catch (e) {
      console.log(e);
    }
    // history.push(`/admin/payment/${id}`)
  };

  // handleSelectPrice = (data, index) => {
  //   this.setState({
  //     isOpenPriceModal: true,
  //     serviceName: data.item_desc,
  //     serviceDetail: data,
  //   });
  // };

  handleSelectPrice = (data, index) => {
    if (data.item_div === "1") {
      if (this.props.tokenDetails.retailbatchsno) {
        const updatedUomprice = data.uomprice.map((uom) => ({
          ...uom,
          verify_serial: "",
        }));
        this.setState({
          isOpenPriceModal: true,
          serviceDetail: {
            ...data,
            uomprice: updatedUomprice,
          },
          serviceName: data.item_desc,
        });
      } else {
        this.setState({
          isOpenPriceModal: true,
          serviceDetail: data,
          serviceName: data.item_desc,
        });
      }
    } else if (data.is_duration_product === 1) {
      this.setState({
        isOpenDuration: true,
        serviceDetail: data,
        total: data.item_price,
        serviceName: data.item_desc,
        pricePerHour: Number(data.item_price),
      });
    } else if (data.item_div === "3") {
      this.setState({
        serviceDetail: data,
        serviceName: data.item_desc,
      });
      this.handleAddCart(data);
    } else {
      this.handleAddCart(data);
    }
  };

  handleBeforeAddCart = async (data, price, id, qty, index) => {
    let {
      formQty,
      formHoldQty,
      holdSelectedReason,
      focSelectedReason,
      serviceDetail,
    } = this.state;

    formQty = data.uomprice[index]["formQty"];
    formHoldQty = data.uomprice[index]["formHoldQty"];
    if (data.uomprice[index]["holdSelectedReason"]) {
      holdSelectedReason = data.uomprice[index]["holdSelectedReason"];
    } else {
      holdSelectedReason = "";
    }
    if (data.uomprice[index]["focSelectedReason"]) {
      focSelectedReason = data.uomprice[index]["focSelectedReason"];
    } else {
      focSelectedReason = "";
    }

    await this.setState({
      formQty,
      formHoldQty,
      holdSelectedReason,
      focSelectedReason,
    });

    this.handleAddCart(data, price, id, qty, index);
  };

  handleAddCart = (
    data,
    price,
    id,
    qty,
    index,
    voucherNumbers,
    voucherPrice,
    openPackage // Open Package
  ) => {
    let { serial_no, hours, minutes, total, isVoucherActive } = this.state;
    const isOpenPackage =
      data?.is_open_prepaid &&
      data?.item_desc === "Open Package" &&
      !data?.packageCode;
    if (isOpenPackage) {
      return;
    }

    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    // if (!openPackage) {
    //   // Open Package
    //   if (data?.item_div === "3" && data?.is_open_prepaid === true) {
    //     this.setState({
    //       packageData: data,
    //       isOpenPackagePopup: true,
    //       isLoading: false,
    //     });
    //     return;
    //   }
    // } // Open Package

    if (!voucherNumbers) {
      if (data.item_div === "4" && this.props.tokenDetails?.flexibleVoucher) {
        this.setState({
          previousVoucher: data,
          isVoucherActive: true,
          isLoading: false,
        });
        return;
      }
    }
    if (this.state.holdCheckbox) {
      if (this.state.holdSelectedReason == "") {
        Toast({
          type: "error",
          message: "Please select HOLD Reason",
        });
        this.setState({
          isLoading: false,
        });
        return false;
      }
    }
    if (this.state.focCheckbox) {
      if (this.state.focSelectedReason == "") {
        Toast({
          type: "error",
          message: "Please select FOC Reason",
        });
        this.setState({
          isLoading: false,
        });
        return;
      } else {
        this.setState({
          isLoading: false,
        });
        this.handleAddFOC(data, price, id, qty);
        return;
      }
    }
    let { basicApptDetail } = this.props;

    let payload = [];
    //let { search_serial_no } = this.state;

    let totalMinutes = hours * 60 + minutes;
    let totalPrice = total / totalMinutes;
    let obj = {
      cust_noid: this.props.custId,
      cart_date: dateFormat(new Date(), "yyyy-mm-dd"),
      itemcodeid: data.id,
      packageitemcode: data?.packageCode
        ? data?.packageCode
        : data?.item_desc === "Open Package"
        ? data?.item_code
        : undefined,
      price: data.is_duration_product
        ? totalPrice.toFixed(4)
        : price
        ? price
        : data.item_price,
      qty: data.is_duration_product
        ? totalMinutes
        : this.state.formQty && this.state.formQty > 1
        ? this.state.formQty
        : 1,
      is_foc: this.state.focCheckbox,
      focreason: this.state.focSelectedReason,
      holdreason: this.state.holdSelectedReason,
      holditemqty: Number(this.state.formHoldQty),
      item_uom: id == 0 ? "" : id,
      is_service: true,
      itemstatus: data?.itemstatus ? data?.itemstatus : "",
    };

    // check searial number only we can add obj
    // if (data && data?.uomprice && data?.uomprice[index]?.serial_no) {
    //   obj.batch_sno = data?.uomprice[index]?.serial_no;
    // }

    if (this.props.tokenDetails?.retailbatchsno && data.item_div === "1") {
      if (data.uomprice[index].serial_no !== "") {
        if (data.uomprice[index].verify_serial.length !== 13) {
          Toast({
            type: "error",
            message: "Item Serial must contain 13 characters",
          });
          this.setState({
            isLoading: false,
          });
          return;
        } else if (
          data.uomprice[index].serial_no !== data.uomprice[index].verify_serial
        ) {
          Toast({
            type: "error",
            message:
              "Item Serial Does not Match with the Product Serial Number",
          });
          this.setState({
            isLoading: false,
          });
          return;
        }
        obj.batch_sno = serial_no;
      } else {
        if (data.uomprice[index].verify_serial.length !== 13) {
          Toast({
            type: "error",
            message: "Item Serial must contain 13 characters",
          });
          this.setState({
            isLoading: false,
          });
          return;
        }

        obj.batch_sno = serial_no;
      }
    }
    if (id) {
      obj["item_uom"] = id;
    }
    if (voucherNumbers) {
      obj["voucher_no"] = voucherNumbers;
      obj["unit_price"] = voucherPrice;
      obj["qty"] = voucherNumbers?.length;
    }
    let { serviceDetail, newVoucherData } = this.state;
    let DefaultstaffIds = "";
    if (this.props.defaultStaffId) {
      DefaultstaffIds = this.props.defaultStaffId
        .map((e) => e.value)
        .reduce((a, e) => (a === "" ? e : a + "," + e), "");
    }
    payload.push(obj);

    if (data.uomprice) {
      if (
        this.props.tokenDetails?.retailbatchsno &&
        payload[index]?.batch_sno
      ) {
        this.props
          .commonCreateApi(
            `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}`,
            payload
          )
          .then(async (res) => {
            let new_cart_id = res.data[0]?.id;
            let defaultStaff = DefaultstaffIds;
            this.props.handleCartCreated(res);
            await this.setState({
              activeTab: "treatment",
              isOpenPriceModal: false,
              isOpenDuration: false,
              isServicePopModal: false,
              focCheckbox: false,
              holdCheckbox: false,
              holdSelectedReason: "",
              focSelectedReason: "",
              serial_no: "",
              formQty: 1,
              formHoldQty: 0,
              hours: "",
              minutes: "",
              total: "",
              treatmentCartId: new_cart_id,
              isLoading: false,
            });
            if (serviceDetail.uomprice) {
              for (let result of serviceDetail.uomprice) {
                result["formQty"] = 1;
                result["formHoldQty"] = 0;
                result["holdSelectedReason"] = "";
                result["focSelectedReason"] = "";
                this.setState({
                  serviceDetail: result,
                });
              }
            }
          });
      } else if (!this.props.tokenDetails?.retailbatchsno) {
        this.props
          .commonCreateApi(
            `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}`,
            payload
          )
          .then(async (res) => {
            let new_cart_id = res.data[0]?.id;
            let defaultStaff = DefaultstaffIds;
            this.props.handleCartCreated(res);
            await this.setState({
              activeTab: "treatment",
              isOpenPriceModal: false,
              isServicePopModal: false,
              focCheckbox: false,
              holdCheckbox: false,
              isOpenDuration: false,
              holdSelectedReason: "",
              focSelectedReason: "",
              serial_no: "",
              formQty: 1,
              formHoldQty: 0,
              hours: "",
              minutes: "",
              total: "",
              treatmentCartId: new_cart_id,
              isLoading: false,
            });
            if (serviceDetail.uomprice) {
              for (let result of serviceDetail.uomprice) {
                result["formQty"] = 1;
                result["formHoldQty"] = 0;
                result["holdSelectedReason"] = "";
                result["focSelectedReason"] = "";
                this.setState({
                  serviceDetail: result,
                });
              }
            }
          });
      } else if (
        this.props.tokenDetails?.retailbatchsno &&
        !payload[index]?.batch_sno
      ) {
        Toast({
          type: "error",
          message: "Please Scan serial number for the product",
        });
        this.setState({
          isLoading: false,
        });
      }
    } else {
      let apiUrl = `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}`;

      if (data?.is_duration_product === 1) {
        apiUrl += `&dur_amt=${total}`;
      }
      this.props.commonCreateApi(apiUrl, payload).then(async (res) => {
          let new_cart_id = res.data[0]?.id;
          let getCartId = res?.data && res?.data[0]?.cartid;
          let defaultStaff = DefaultstaffIds;
          if (voucherNumbers) {
            let isDiscount = newVoucherData?.some(
              (list) => list?.discount === "Yes"
            );
            let mapDiscount = {
              cartId: new_cart_id,
              isDiscount,
            };

            let getDiscounts = JSON.parse(
              localStorage.getItem("voucher_discount") || "[]"
            );

            let getVoucherNumbers = JSON.parse(
              localStorage.getItem("voucher_numbers") || "[]"
            );
            getDiscounts.push(mapDiscount);

            getVoucherNumbers = [...getVoucherNumbers, ...voucherNumbers];
            localStorage.setItem(
              "voucher_discount",
              JSON.stringify(getDiscounts)
            );
            localStorage.setItem(
              "voucher_numbers",
              JSON.stringify(getVoucherNumbers)
            );

            this.handleVoucherHistory(getCartId);
          }
          this.props.handleCartCreated(res);
          await this.setState({
            activeTab: "treatment",
            isOpenPriceModal: false,
            isServicePopModal: false,
            focCheckbox: false,
            holdCheckbox: false,
            isOpenDuration: false,
            holdSelectedReason: "",
            focSelectedReason: "",
            serial_no: "",
            formQty: 1,
            formHoldQty: 0,
            hours: "",
            minutes: "",
            total: "",
            treatmentCartId: new_cart_id,
            isOpenPackagePopup: false, // Open Package
            isLoading: false,
          });
          if (serviceDetail.uomprice) {
            for (let result of serviceDetail.uomprice) {
              result["formQty"] = 1;
              result["formHoldQty"] = 0;
              result["holdSelectedReason"] = "";
              result["focSelectedReason"] = "";
              this.setState({
                serviceDetail: result,
              });
            }
          }
        })
        .catch((err) => {
          this.setState({
            isLoading: false,
          });
        });
    }
  };
  handleFocImageClick(data) {
    if (data.item_div === "1") {
      this.setState({
        isOpenPriceModal: true,
        serviceDetail: data,
        focCheckbox: true,
      });
    } else {
      this.setState({
        isServicePopModal: true,
        serviceDetail: data,
        focCheckbox: true,
      });
    }
  }
  handleDetailAddCartClick(data) {
    if (data.item_div === "1") {
      this.setState({
        isOpenPriceModal: true,
        serviceDetail: data,
      });
    } else if (
      data.item_div === "3" &&
      String(data.item_type).toUpperCase() === "SINGLE"
    ) {
      this.setState({
        isServicePopModal: true,
        serviceDetail: data,
      });
    } else {
      this.handleAddCart(data);
    }
  }

  handleCheck = () => {
    console.log("Test1092");
  };
  handleBeforeAddFOC = async (data, price, id, qty, index) => {
    let {
      formQty,
      formHoldQty,
      holdSelectedReason,
      focSelectedReason,
      serviceDetail,
    } = this.state;
    formQty = data.uomprice[index]["formQty"];
    formHoldQty = data.uomprice[index]["formHoldQty"];
    if (data.uomprice[index]["holdSelectedReason"]) {
      holdSelectedReason = data.uomprice[index]["holdSelectedReason"];
    } else {
      holdSelectedReason = "";
    }
    if (data.uomprice[index]["focSelectedReason"]) {
      focSelectedReason = data.uomprice[index]["focSelectedReason"];
    } else {
      focSelectedReason = "";
    }

    await this.setState({
      formQty,
      formHoldQty,
      holdSelectedReason,
      focSelectedReason,
    });
    console.log("Test1118");
    this.handleAddFOC(data, price, id, qty, index);
  };
  handleAddFOC = (data, price, id, qty, index) => {
    let { basicApptDetail } = this.props;
    let { serial_no } = this.state;
    //let { search_serial_no } = this.state;

    let payload = [];
    let obj = {
      cust_noid: this.props.custId,
      cart_date: dateFormat(new Date(), "yyyy-mm-dd"),
      itemcodeid: data.id,
      price: price ? price : data.item_price,
      qty:
        this.state.formQty && this.state.formQty > 1 ? this.state.formQty : 1,
      is_foc: this.state.focCheckbox,
      focreason: this.state.focSelectedReason,
      holdreason: this.state.holdSelectedReason,
      holditemqty: Number(this.state.formHoldQty),
      item_uom: id == 0 ? "" : id,
    };
    console.log("Test1140");
    if (this.props.tokenDetails?.retailbatchsno) {
      obj.batch_sno = serial_no;
    }
    // check searial number only we can add obj
    // if (data && data?.uomprice && data?.uomprice[index]?.serial_no) {
    //   obj.batch_sno = data?.uomprice[index]?.serial_no;
    // }

    if (id) {
      obj["item_uom"] = id;
    }
    let DefaultstaffIds = "";
    let { serviceDetail } = this.state;
    if (this.props.defaultStaffId) {
      DefaultstaffIds = this.props.defaultStaffId
        .map((e) => e.value)
        .reduce((a, e) => (a === "" ? e : a + "," + e), "");
    }
    payload.push(obj);
    this.props
      .commonCreateApi(
        `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}&is_foc=1`,
        payload
      )
      .then((res) => {
        console.log(res, "FOCRes");
        this.props.handleCartCreated(res);
        this.setState({
          activeTab: "treatment",
          isOpenPriceModal: false,
          isServicePopModal: false,
          focCheckbox: false,
          holdCheckbox: false,
          holdSelectedReason: "",
          focSelectedReason: "",
          formQty: 1,
          formHoldQty: 0,
          treatmentCartId: res.data[0].id,
        });
        if (serviceDetail.uomprice) {
          for (let result of serviceDetail.uomprice) {
            result["formQty"] = 1;
            result["formHoldQty"] = 0;
            result["holdSelectedReason"] = "";
            result["focSelectedReason"] = "";
            this.setState({
              serviceDetail: result,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
    // this.props
    //   .getCommonApi(
    //     `itemcart/Check/?cart_date=${dateFormat(
    //       new Date(),
    //       "yyyy-mm-dd"
    //     )}&cust_noid=${this.props.custId}`
    //   )
    //   .then((res) => {
    //     if (res.data.length === 0) {
    //       this.props
    //         .commonCreateApi("itemcart/?is_foc=1", payload)
    //         .then((res) => {
    //           this.props.handleCartCreated(res);
    //           this.setState({
    //             activeTab: "treatment",
    //             isOpenPriceModal: false,
    //             isServicePopModal: false,
    //             focCheckbox: false,
    //             holdCheckbox: false,
    //             holdSelectedReason: "",
    //             focSelectedReason: "",
    //             formQty: 1,
    //             formHoldQty: 0,
    //           });
    //           if (serviceDetail.uomprice) {
    //             for (let result of serviceDetail.uomprice) {
    //               result["formQty"] = 1;
    //               result["formHoldQty"] = 0;
    //               result["holdSelectedReason"] = "";
    //               result["focSelectedReason"] = "";
    //               this.setState({
    //                 serviceDetail: result,
    //               });
    //             }
    //           }
    //         });
    //     } else {
    //       this.props
    //         .commonCreateApi(
    //           `itemcart/?cart_id=${res.cart_id}&logstaff_id=${DefaultstaffIds}&is_foc=1`,
    //           payload
    //         )
    //         .then((res) => {
    //           this.props.handleCartCreated(res);
    //           this.setState({
    //             activeTab: "treatment",
    //             isOpenPriceModal: false,
    //             isServicePopModal: false,
    //             focCheckbox: false,
    //             holdCheckbox: false,
    //             holdSelectedReason: "",
    //             focSelectedReason: "",
    //             formQty: 1,
    //             formHoldQty: 0,
    //           });
    //           if (serviceDetail.uomprice) {
    //             for (let result of serviceDetail.uomprice) {
    //               result["formQty"] = 1;
    //               result["formHoldQty"] = 0;
    //               result["holdSelectedReason"] = "";
    //               result["focSelectedReason"] = "";
    //               this.setState({
    //                 serviceDetail: result,
    //               });
    //             }
    //           }
    //         });
    //     }
    //  });
  };

  handleMenu = async (data, name) => {
    let { activeMenu, activeMenuName, isDurationProduct } = this.state;
    activeMenu = data;
    activeMenuName = name;
    isDurationProduct = false;
    await this.setState({
      activeMenu,
      activeMenuName,
      rangeId: "",
      rangeOption: [],
      menuOption: [],
      itemList: [],
      menuId: "",
      formFields: {
        search: "",
      },
      page: 1,
      isDurationProduct,
    });
    if (activeMenu !== "Favorites") {
      this.getMenus();
    }
    // if (activeMenu === "Favorites") {
    //     this.getItemList({})
    // }
    // this.getRange();
    this.getItemList({});
  };

  // New menu click event ****************
  handleMenuClick = async (data) => {
    const { currentMenus, prevMenus, activeLevel } = this.state;
    if (data?.child?.length > 0) {
      let active = activeLevel + 1;
      this.setState({ activeLevel: active });
      this.setPrevMenuSet(currentMenus);
      this.setCurrentMenuSet(data.child);
      // await this.setState({ activeMenu: data.menuCode });
      // this.getItemList({});
    } else {
      await this.setState({ activeMenu: data.menuCode });
      this.getItemList({});
    }
  };

  // go back to prev menu event ***************
  handleGoPrev = async () => {
    // alert("activeMenu" + this.state.activeMenu);
    const { activeLevel, prevMenus, menuData } = this.state;

    let allMenu = getAllNestedMenu(menuData);

    allMenu = allMenu.filter(
      (item) => item.parentCode == prevMenus?.[0].parentCode
    );

    // console.log("allmenu" + JSON.stringify(allMenu[0].parentCode));

    switch (activeLevel) {
      case 1:
        await this.setState({
          prevMenus: [],
          currentMenus: menuData,
          activeLevel: 0,
          itemList: [],
        });

        this.setCurrentMenuSet(this.state.menuData);
        return true;
      case 2:
        await this.setState({
          prevMenus: allMenu,
          currentMenus: prevMenus,
          activeLevel: 1,
          itemList: [],
        });
        this.setCurrentMenuSet(this.state.prevMenus);
        return true;
      case 3:
        await this.setState({
          prevMenus: allMenu,
          currentMenus: prevMenus,
          activeLevel: 2,
          itemList: [],
        });
        this.setCurrentMenuSet(this.state.prevMenus);
        return true;
      case 4:
        await this.setState({
          prevMenus: allMenu,
          currentMenus: prevMenus,
          activeLevel: 3,
          itemList: [],
        });
        this.setCurrentMenuSet(this.state.prevMenus);
        return true;

      default:
        return true;
    }
  };

  handlePagination = async (page) => {
    await this.setState({ page: page });
    this.getItemList({ page: page });
  };

  // handleMenuPagination
  handleMenuPagination = async (page) => {
    let originalDataList = this.state.menuListOriginalData;
    let limitValue = 8;
    var metaObj = {
      per_page: limitValue,
      current_page: page,
      total: originalDataList,
      total_pages: Math.ceil(originalDataList.length / 8),
    };

    this.setState({ paginationItemList: metaObj });
    let sliceDataMenu = originalDataList.slice(
      page * limitValue - limitValue,
      page * limitValue
    );

    await this.setState({
      currentMenus: sliceDataMenu,
      activeMenu: sliceDataMenu[0].menuCode,
    });
    await this.getItemList({});
  };

  handleMenuChange = async ({ target: { value, name } }) => {
    this.setState({ rangeId: "" });
    let menuId = Object.assign({}, this.state.menuId);
    let { activeMenu, isDurationProduct, menuOption } = this.state;

    menuId = value;

    let findMenu = menuOption?.find((list) => list.value === Number(menuId));
    isDurationProduct = findMenu?.durationProduct === 1;

    await this.setState({ menuId, isDurationProduct, page: 1 });
    if (activeMenu !== "Favorites") {
      this.getRange();
    }

    this.getItemList({});
  };

  // handleCloseDialog = () => {
  //   let { isOpenPriceModal } = this.state;
  //   isOpenPriceModal = false;
  //   this.setState({
  //     isOpenPriceModal,
  //   });
  // };
  handleCloseDialog = () => {
    this.setState({
      isOpenPriceModal: false,
      formQty: 1,
      formHoldQty: 0,
      focCheckbox: false,
      holdCheckbox: false,
      holdSelectedReason: "",
      focSelectedReason: "",
      serial_no: "",
    });
  };
  handleCloseDuration = () => {
    this.setState({
      isOpenDuration: false,
    });
  };
  handleVoucherCloseModal = () => {
    this.setState({
      isVoucherActive: false,
    });
  };
  handleServicePopCloseDialog = () => {
    this.setState({
      isServicePopModal: false,
      formQty: 1,
      formHoldQty: 0,
      focCheckbox: false,
      holdCheckbox: false,
      holdSelectedReason: "",
      focSelectedReason: "",
    });
  };

  handleRangeChange = async ({ target: { value, name } }) => {
    let rangeId = Object.assign({}, this.state.rangeId);
    let rangeName = Object.assign({}, this.state.rangeName);
    let { rangeOption } = this.state;
    rangeId = value;
    // rangeName = name;

    for (let key of rangeOption) {
      if (key.value == value) {
        rangeName = key.label;
      }
    }

    await this.setState({
      rangeId,
      rangeName,
      page: 1,
    });
    this.getItemList({});
  };

  handleQtyChange = async (value, name, index) => {
    let { serviceDetail, formQty } = this.state;
    let { uomprice } = serviceDetail;
    //uomprice[index][name] = value;
    formQty = Number(value);
    if (Number(index) == -1) {
      await this.setState({ formQty });
    } else {
      serviceDetail.uomprice[index][name] = Number(value);
      await this.setState({ serviceDetail, formQty });
    }
  };

  handleBatchNoChange = async (value, name, index) => {
    let { serviceDetail, serial_no } = this.state;
    serial_no = value;

    serviceDetail.uomprice[index][name] = value;
    await this.setState({ serviceDetail, serial_no });
  };

  // handleQtyChange = async ({ target: { value, name } }, index) => {
  //   let { serviceDetail, formQty } = this.state;
  //   let { uomprice } = serviceDetail;
  //   //uomprice[index][name] = value;
  //   formQty = value;
  //   if (Number(index) == -1) {
  //     await this.setState({ formQty });
  //   } else {
  //     serviceDetail.uomprice[index][name] = value;
  //     await this.setState({ serviceDetail, formQty });
  //   }
  // };

  handleHoldQtyChange = async (value, name, index) => {
    let { formQty, serviceDetail, formHoldQty } = this.state;

    if (Number(value) >= 1 && Number(formQty) >= Number(value)) {
      this.setState({ holdCheckbox: true });
    } else {
      this.setState({ holdCheckbox: false, holdSelectedReason: "" });
      serviceDetail.uomprice[index][name] = "";
      serviceDetail.uomprice[index]["holdSelectedReason"] = "";
      this.setState({
        serviceDetail,
      });
    }
    if (Number(formQty) >= Number(value)) {
      serviceDetail.uomprice[index][name] = Number(value);
      formHoldQty = Number(value);
      await this.setState({ serviceDetail, formHoldQty });
    } else {
      Toast({
        type: "error",
        message: "Value Should be less than Qty",
      });
      return;
    }
  };
  handleHoldCheckBox = () => {
    this.setState({
      holdCheckbox: !this.state.holdCheckbox,
    });
  };
  handleFOCCheckBox = () => {
    this.setState({
      focCheckbox: !this.state.focCheckbox,
    });
  };
  handleFOCDropdownChange = async ({ target: { value, name } }, index) => {
    let { serviceDetail, focSelectedReason } = this.state;
    focSelectedReason = value;
    if (Number(index) == -1) {
      await this.setState({
        focSelectedReason,
      });
    } else {
      serviceDetail.uomprice[index][name] = value;
      await this.setState({
        serviceDetail,
        focSelectedReason,
      });
    }
  };

  handleServiceItemCourse = (data, price, id, qty, index) => {
    let { basicApptDetail } = this.props;
    let { search_serial_no } = this.state;
    let payload = [];
    let obj = {
      cust_noid: this.props.custId,
      cart_date: dateFormat(new Date(), "yyyy-mm-dd"),
      itemcodeid: data.id,
      price: price ? price : data.item_price,
      qty:
        this.state.formQty && this.state.formQty > 1 ? this.state.formQty : 1,
      is_foc: this.state.focCheckbox,
      focreason: this.state.focSelectedReason,
      holdreason: this.state.holdSelectedReason,
      holditemqty: Number(this.state.formHoldQty),
      item_uom: id == 0 ? "" : id,
      is_service: false,
    };

    // check searial number only we can add obj
    if (search_serial_no) {
      obj.batch_sno = search_serial_no;
    }

    if (id) {
      obj["item_uom"] = id;
    }
    let DefaultstaffIds = "";
    if (this.props.defaultStaffId) {
      DefaultstaffIds = this.props.defaultStaffId
        .map((e) => e.value)
        .reduce((a, e) => (a === "" ? e : a + "," + e), "");
    }
    payload.push(obj);

    this.props
      .commonCreateApi(
        `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}`,
        payload
      )
      .then(async (res) => {
        if (res.status == 201) {
          console.log(res, "else condition cart create response");
          this.props.handleCartCreated(res);
          await this.setState({
            activeTab: "treatment",
            isOpenPriceModal: false,
            isCoursePopupId: res.data[0].id,
            treatmentCartId: res.data[0].id,
          });
          let editCart = {};
          editCart["id"] = res.data[0].id;
          this.props.handleCardItemCourseClick(editCart);
        }
      });
    // this.props
    //   .getCommonApi(
    //     `itemcart/Check/?cart_date=${dateFormat(
    //       new Date(),
    //       "yyyy-mm-dd"
    //     )}&cust_noid=${this.props.custId}`
    //   )
    //   .then((res) => {
    //     console.log(res, "check api response");
    //     if (res.data.length === 0) {
    //       this.props
    //         .commonCreateApi(
    //           `itemcart/?logstaff_id=${DefaultstaffIds}`,
    //           payload
    //         )
    //         .then(async (res) => {
    //           if (res.status == 201) {
    //             this.props.handleCartCreated(res);
    //             await this.setState({
    //               activeTab: "treatment",
    //               isOpenPriceModal: false,
    //               isCoursePopupId: res.data[0].id,
    //             });
    //             let editCart = {};
    //             editCart["id"] = res.data[0].id;
    //             this.props.handleCardItemCourseClick(editCart);
    //           }
    //         });
    //     } else {
    //       this.props
    //         .commonCreateApi(
    //           `itemcart/?cart_id=${res.cart_id}&logstaff_id=${DefaultstaffIds}`,
    //           payload
    //         )
    //         .then(async (res) => {
    //           if (res.status == 201) {
    //             console.log(res, "else condition cart create response");
    //             this.props.handleCartCreated(res);
    //             await this.setState({
    //               activeTab: "treatment",
    //               isOpenPriceModal: false,
    //               isCoursePopupId: res.data[0].id,
    //             });
    //             let editCart = {};
    //             editCart["id"] = res.data[0].id;
    //             this.props.handleCardItemCourseClick(editCart);
    //           }
    //         });
    //     }
    //  });
  };

  handleOpenPrepaidClick = (data, price, id, qty, index) => {
    let { basicApptDetail } = this.props;
    let { search_serial_no } = this.state;
    if (data.item_div === "3") {
      // Open Package
      console.log(data, "data");
      this.setState({
        packageData: data,
        isOpenPackagePopup: true,
      });
    } else {
      let payload = [];
      let obj = {
        cust_noid: this.props.custId,
        cart_date: dateFormat(new Date(), "yyyy-mm-dd"),
        itemcodeid: data.id,
        price: price ? price : data.item_price,
        qty:
          this.state.formQty && this.state.formQty > 1 ? this.state.formQty : 1,
        is_foc: this.state.focCheckbox,
        focreason: this.state.focSelectedReason,
        holdreason: this.state.holdSelectedReason,
        holditemqty: Number(this.state.formHoldQty),
        item_uom: id == 0 ? "" : id,
      };

      // check searial number only we can add obj
      if (search_serial_no) {
        obj.batch_sno = search_serial_no;
      }

      if (id) {
        obj["item_uom"] = id;
      }
      let DefaultstaffIds = "";
      if (this.props.defaultStaffId) {
        DefaultstaffIds = this.props.defaultStaffId
          .map((e) => e.value)
          .reduce((a, e) => (a === "" ? e : a + "," + e), "");
      }
      payload.push(obj);
      this.props
        .commonCreateApi(
          `itemcart/?cart_id=${""}&logstaff_id=${DefaultstaffIds}`,
          payload
        )
        .then(async (res) => {
          console.log(res, "else condition op cart create response");
          if (res.status == 201) {
            this.props.handleCartCreated(res);
            await this.setState({
              activeTab: "treatment",
              isOpenPriceModal: false,
              treatmentCartId: res.data[0].id,
            });
            let editCart = {};
            editCart["id"] = res.data[0].id;

            this.props.handleCardPrepaidClick(editCart);
          }
        });
      // this.props
      //   .getCommonApi(
      //     `itemcart/Check/?cart_date=${dateFormat(
      //       new Date(),
      //       "yyyy-mm-dd"
      //     )}&cust_noid=${this.props.custId}`
      //   )
      //   .then((res) => {
      //     console.log(res, "check api response");
      //     if (res.data.length === 0) {
      //       this.props
      //         .commonCreateApi(
      //           `itemcart/?logstaff_id=${
      //             DefaultstaffIds ? DefaultstaffIds : Number(DefaultstaffIds)
      //           }`,
      //           payload
      //         )
      //         .then(async (res) => {
      //           console.log(res, "if condition op cart create response");
      //           if (res.status == 201) {
      //             this.props.handleCartCreated(res);
      //             await this.setState({
      //               activeTab: "treatment",
      //               isOpenPriceModal: false,
      //             });
      //             let editCart = {};
      //             editCart["id"] = res.data[0].id;
      //             this.props.handleCardPrepaidClick(editCart);
      //           }
      //         });
      //     } else {
      //       this.props
      //         .commonCreateApi(
      //           `itemcart/?cart_id=${res.cart_id}&logstaff_id=${DefaultstaffIds}`,
      //           payload
      //         )
      //         .then(async (res) => {
      //           console.log(res, "else condition op cart create response");
      //           if (res.status == 201) {
      //             this.props.handleCartCreated(res);
      //             await this.setState({
      //               activeTab: "treatment",
      //               isOpenPriceModal: false,
      //             });
      //             let editCart = {};
      //             editCart["id"] = res.data[0].id;
      //             this.props.handleCardPrepaidClick(editCart);
      //           }
      //         });
      //     }
      //   });
    } // Open Package
  };
  handleHoldDropdownChange = async ({ target: { value, name } }, index) => {
    let { serviceDetail, holdSelectedReason } = this.state;
    holdSelectedReason = value;
    if (Number(index) == -1) {
      await this.setState({
        holdSelectedReason,
      });
    } else {
      serviceDetail.uomprice[index]["holdSelectedReason"] = value;
      await this.setState({
        serviceDetail,
        holdSelectedReason,
      });
    }
  };
  handleHoursChange = (e) => {
    const newHours = parseInt(e.target.value, 10) || 0;
    this.setState({ hours: newHours });
  };

  handleMinutesChange = (e) => {
    const newMinutes = parseInt(e.target.value, 10) || 0;
    this.setState({ minutes: newMinutes });
  };

  handleTotalChange = (e) => {
    this.setState({ total: e.target.value });
  };

  calculateTotal = () => {
    const { hours, minutes, pricePerHour } = this.state;
    console.log(pricePerHour, "price");
    const totalHours = hours + minutes / 60;
    const totalMinutes = hours * 60 + minutes;
    const roundedTotal = (totalMinutes * pricePerHour).toFixed(2);
    this.setState({ total: roundedTotal, totalHours });
  };

  handleTcm = () => {
    let { custId, cartId } = this.props;
    let { treatmentCartId } = this.state;

    if (!custId) {
      Toast({
        type: "error",
        message: "Please select customer",
      });
      return;
    }
    if (!cartId) {
      Toast({
        type: "error",
        message: "Please select Cart",
      });
      return;
    }
    this.props.getCommonApi(`tcmheaderdata/?cartid=${cartId}`).then((res) => {
      let getInjuryPart = res[0]?.injuirypart?.split(",")?.map((list) => ({
        label: list,
        value: list,
      }));
      this.setState({
        injuries: getInjuryPart,
        injuryPeriod: res[0]?.injuiryperiod,
        symptom: res[0]?.symptoms,
        otherInjury: res[0]?.otherpart,
        tcmId: res[0]?.id,
        physician: res[0]?.emp_no,
      });
    });
    this.props
      .getCommonApi("employeelistbytype/?employeetype=100004")
      .then((res) => {
        let options = res?.data?.map((list) => ({
          label: list.display_name,
          value: list.pk,
        }));
        this.setState({
          physicianOptions: options,
        });
      });
    this.setState({
      isTcm: true,
    });
  };

  handleCloseTcm = () => {
    this.setState({
      isTcm: false,
    });
  };
  handleMultiSelectInjury = (data = []) => {
    let { injuries } = this.state;
    injuries = data;
    this.setState({ injuries });
  };
  handleTcmSave = () => {
    let {
      injuries,
      otherInjury,
      injuryPeriod,
      symptom,
      tcmId,
      physician,
      physicianOptions,
    } = this.state;
    let { cartId } = this.props;
    let injuryPart = injuries.map((list) => list.value).join(",");
    let getPhysician = physicianOptions?.find(
      (list) => Number(list.value) === Number(physician)
    );
    let data = {
      cartid: cartId,
      injuirypart: injuryPart,
      otherpart: otherInjury,
      injuiryperiod: injuryPeriod,
      symptoms: symptom,
      emp_no: physician,
      physician: getPhysician?.label,
    };
    if (tcmId) {
      this.props
        .commonUpdateApi(`tcmheaderdata/`, data)
        .then((res) => {
          this.setState({
            isTcm: false,
            injuries: [],
            otherInjury: "",
            injuryPeriod: "",
            symptom: "",
            physician: "",
          });
        })
        .catch((err) => console.log(err, "error"));
    } else {
      this.props
        .commonCreateApi(`tcmheaderdata/`, data)
        .then((res) => {
          this.setState({
            isTcm: false,
            injuries: [],
            otherInjury: "",
            injuryPeriod: "",
            symptom: "",
          });
        })
        .catch((err) => console.log(err, "error"));
    }
  };
  handleInputChange = async ({ target: { name, value } }) => {
    let { physician, voucherQuantity } = this.state;
    if (name === "physician") {
      physician = value;
      this.setState({ physician });
    }
    if (name === "voucherQuantity") {
      voucherQuantity = value;
      this.setState({ voucherQuantity });
    }
  };
  handleVoucherNumberChange = ({ target: { value, name } }) => {
    let { voucherNumbers } = this.state;
    voucherNumbers = value;
    this.setState({ voucherNumbers });
  };
  handleVoucherNumbers = () => {
    let { voucherNumbers, selectedCards } = this.state;
    const allVoucherNumbers = this.parseVoucherNumbers(voucherNumbers);

    this.props
      .getCommonApi(
        `vouchercheck/?voucher_number=${allVoucherNumbers}&status=Sold`
      )
      .then((res) => {
        let totalAmount = 0;
        let getVoucherNumbers = JSON.parse(
          localStorage.getItem("voucher_numbers") || "[]"
        );

        const filteredVouchers = res?.vouchers?.filter((voucher) => {
          return !getVoucherNumbers.some(
            (card) => card === voucher.voucher_code
          );
        });
        const updatedVouchers = filteredVouchers?.map((list) => {
          totalAmount += list?.voucher_value;
          // if (list.expiry_date) {
          // const updatedDate = new Date(list.expiry_date);

          // const formattedDate = updatedDate.toLocaleDateString("en-GB", {
          //   day: "2-digit",
          //   month: "short",
          //   year: "numeric",
          // });
          return {
            ...list,
            discount: list?.discountallowed === true ? "Yes" : "No",
            // expiry_date: formattedDate,
          };
        });
        this.setState({
          newVoucherData: updatedVouchers,
          totalActiveVouchers: filteredVouchers?.length,
          totalVoucherAmount: totalAmount,
        });
      });
  };

  parseVoucherNumbers = (voucherString) => {
    let result = [];
    let vouchers = voucherString.split(",");

    vouchers.forEach((voucher) => {
      let match = voucher.match(/(\D+)(\d+)/);

      if (match) {
        let prefix = match[1];
        let startNumber = parseInt(match[2], 10);
        let numberLength = match[2].length;

        if (voucher.includes("-")) {
          let range = voucher.split("-");
          let start = range[0].slice(prefix.length);
          let end = range[1].slice(prefix.length);
          start = parseInt(start, 10);
          end = parseInt(end, 10);

          for (let i = start; i <= end; i++) {
            result.push(prefix + i.toString().padStart(numberLength, "0"));
          }
        } else {
          let voucherNumber = voucher.slice(prefix.length);
          result.push(prefix + voucherNumber.padStart(numberLength, "0"));
        }
      }
    });

    return result;
  };

  handleSubmitVoucher = () => {
    let { newVoucherData, totalVoucherAmount, previousVoucher } = this.state;
    let voucherNumbers = newVoucherData?.map((list) => list?.voucher_code);
    let voucherPrice = newVoucherData[0]?.voucher_value;
    this.handleAddCart(
      previousVoucher,
      null,
      null,
      null,
      null,
      voucherNumbers,
      voucherPrice
    );
  };

  handleVoucherHistory = (cartId) => {
    let { newVoucherData, totalVoucherAmount, previousVoucher } = this.state;
    let voucherNumbers = newVoucherData?.map((list) => list?.voucher_code);
    let documentNumbers = newVoucherData?.map((list) => list?.doc_no);

    let data = {
      voucher_no: voucherNumbers,
      doc_no: documentNumbers,
      amount: totalVoucherAmount,
      cart_id: cartId,
    };
    this.props.commonCreateApi(`voucher_history/`, data).then((res) => {
      this.setState({
        newVoucherData: [],
        isVoucherActive: false,
        voucherNumbers: null,
        totalVoucherAmount: 0,
        totalActiveVouchers: 0,
      });
    });
  };
  // Open Package
  handleOpenPackageDialog = () => {
    this.setState({
      isOpenPackagePopup: false,
    });
  };

  render() {
    let {
      activeTab,
      formFields,
      menuItems,
      menuOption,
      serial_no,
      menuId,
      activeMenu,
      itemList,
      rangeOption,
      rangeId,
      rangeName,
      activeMenuName,
      serviceName,
      serviceDetail,
      isOpenPriceModal,
      isServicePopModal,
      focReasonList,
      holdReasonList,
      itemDescription,
      prevMenus,
      currentMenus,
      newMenu,
      isOpenDuration,
      hours,
      minutes,
      total,
      isDurationProduct,
      isTcm,
      injuryOptions,
      otherInjury,
      symptom,
      injuryPeriod,
      injuries,
      isVoucherActive,
      previousVoucher,
      physicianOptions,
      physician,
      voucherQuantity,
      voucherNumbers,
      newVoucherData,
      headerDetails,
      totalActiveVouchers,
      totalVoucherAmount,
      isOpenPackagePopup, // Open Package
    } = this.state;

    let { dataList = [], meta = {} } = itemList;
    let { selectedCart, tokenDetails, t } = this.props;
    let { pagination } = meta;
    const lightgreen = "#f0fff0";
    return (
      // <div className="col-5 ">
      <div className="treatment-section  p-2 pt-2">
        <div className="row m-0 search-bar d-flex align-items-center">
          <div
            className="col-12 col-sm-6 col-md-6 col-lg-12 col-xl-6"
            // ref={this.setWrapperRef}
          >
            {this.props.tokenDetails.ipadkey ? (
              <SearchInputKeyboard
                onRef={(ref) => (this.child = ref)}
                onChangeTextInput={(e) => this.handleSearch(e)}
                handleIconSearch={() => {
                  this.handleIconSearch();
                }}
                focusValue={"searchCourseInput"}
                placeHolderText={"Search.."}
                positionAlignmentLeft=" treatmentKeyboardLeft"
                parentPassIntialValue={formFields.search}
              />
            ) : (
              <NormalInput
                placeholder="Search"
                // options={outletList}
                value={formFields.search}
                name="outlet"
                onChange={(e) => this.handleSearch(e.target.value)}
                iconsVisible
                onKeyDown={this.handlecheckIN}
                onClickIcon={() => {
                  this.handleIconSearch();
                }}
              />
            )}
          </div>
          {this.props.tokenDetails?.flgtcm && (
            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <NormalButton
                mainbg={true}
                className="confirm"
                outline={false}
                label="TCM"
                onClick={this.handleTcm}
              />
            </div>
          )}
          {newMenu && (
            <div className="col-12 col-sm-6 col-md-6 col-lg-12 col-xl-6 ">
              {this.state.paginationItemList && (
                <Pagination
                  handlePagination={this.handleMenuPagination}
                  pageMeta={this.state.paginationItemList}
                  bfont={true}
                  customeClassName="justify-content-lg-start justify-content-xl-end"
                />
              )}
            </div>
          )}

          {/* <div onClick={() => this.handlePrepaidModal()}>
            <h6>Prepaid Btn</h6>
          </div> */}

          {/* <div className="col-6 d-flex">
            <svg
              width="143"
              height="35"
              viewBox="0 0 143 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.25"
                y="0.25"
                width="142.5"
                height="34.5"
                fill="white"
                stroke="$primary-color"
                strokeWidth="0.5"
              />
              <path
                d="M28.336 24.128C27.2373 24.128 26.2773 23.8933 25.456 23.424C24.6453 22.944 24.0213 22.2667 23.584 21.392C23.1467 20.5173 22.928 19.4827 22.928 18.288C22.928 17.104 23.1467 16.0747 23.584 15.2C24.0213 14.3253 24.6453 13.6533 25.456 13.184C26.2773 12.7147 27.2373 12.48 28.336 12.48C29.1147 12.48 29.8347 12.6027 30.496 12.848C31.168 13.0827 31.7333 13.4293 32.192 13.888L31.616 15.104C31.0827 14.6667 30.5547 14.352 30.032 14.16C29.52 13.9573 28.96 13.856 28.352 13.856C27.168 13.856 26.2507 14.24 25.6 15.008C24.96 15.776 24.64 16.8693 24.64 18.288C24.64 19.7173 24.96 20.8213 25.6 21.6C26.2507 22.368 27.168 22.752 28.352 22.752C28.96 22.752 29.52 22.656 30.032 22.464C30.5547 22.2613 31.0827 21.9413 31.616 21.504L32.192 22.72C31.7333 23.1787 31.168 23.5307 30.496 23.776C29.8347 24.0107 29.1147 24.128 28.336 24.128ZM37.4373 24.112C36.6479 24.112 35.9546 23.9413 35.3573 23.6C34.7599 23.2587 34.2959 22.7733 33.9653 22.144C33.6453 21.5147 33.4853 20.7787 33.4853 19.936C33.4853 19.0933 33.6453 18.3573 33.9653 17.728C34.2959 17.088 34.7599 16.5973 35.3573 16.256C35.9546 15.9147 36.6479 15.744 37.4373 15.744C38.2159 15.744 38.9039 15.9147 39.5013 16.256C40.0986 16.5973 40.5573 17.088 40.8773 17.728C41.2079 18.3573 41.3733 19.0933 41.3733 19.936C41.3733 20.7787 41.2079 21.5147 40.8773 22.144C40.5573 22.7733 40.0986 23.2587 39.5013 23.6C38.9039 23.9413 38.2159 24.112 37.4373 24.112ZM37.4213 22.832C38.1679 22.832 38.7386 22.5867 39.1333 22.096C39.5279 21.6053 39.7253 20.8853 39.7253 19.936C39.7253 19.008 39.5226 18.2933 39.1173 17.792C38.7226 17.2907 38.1626 17.04 37.4373 17.04C36.7013 17.04 36.1306 17.2907 35.7253 17.792C35.3199 18.2933 35.1173 19.008 35.1173 19.936C35.1173 20.8853 35.3146 21.6053 35.7093 22.096C36.1146 22.5867 36.6853 22.832 37.4213 22.832ZM52.4621 15.744C54.2541 15.744 55.1501 16.8213 55.1501 18.976V24H53.5341V19.056C53.5341 18.3627 53.4115 17.856 53.1661 17.536C52.9315 17.216 52.5475 17.056 52.0141 17.056C51.3955 17.056 50.9048 17.2693 50.5421 17.696C50.1901 18.1227 50.0141 18.704 50.0141 19.44V24H48.3981V19.056C48.3981 18.3627 48.2755 17.856 48.0301 17.536C47.7955 17.216 47.4115 17.056 46.8781 17.056C46.2595 17.056 45.7688 17.2693 45.4061 17.696C45.0435 18.1227 44.8621 18.704 44.8621 19.44V24H43.2621V18.208C43.2621 17.3653 43.2195 16.608 43.1341 15.936H44.6381L44.7821 17.28C45.0168 16.7893 45.3528 16.4107 45.7901 16.144C46.2275 15.8773 46.7395 15.744 47.3261 15.744C48.5741 15.744 49.3901 16.2613 49.7741 17.296C50.0195 16.816 50.3768 16.4373 50.8461 16.16C51.3261 15.8827 51.8648 15.744 52.4621 15.744ZM61.7373 15.744C62.4413 15.744 63.0653 15.9147 63.6093 16.256C64.1533 16.5973 64.5746 17.0827 64.8733 17.712C65.1719 18.3413 65.3212 19.072 65.3212 19.904C65.3212 20.736 65.1666 21.472 64.8573 22.112C64.5586 22.7413 64.1373 23.232 63.5933 23.584C63.0493 23.936 62.4306 24.112 61.7373 24.112C61.1186 24.112 60.5746 23.984 60.1053 23.728C59.6466 23.4613 59.2999 23.0827 59.0653 22.592V24H57.4653V12.224H59.0653V17.264C59.2999 16.784 59.6466 16.4107 60.1053 16.144C60.5746 15.8773 61.1186 15.744 61.7373 15.744ZM61.3693 22.832C62.0946 22.832 62.6599 22.576 63.0653 22.064C63.4706 21.5413 63.6733 20.8213 63.6733 19.904C63.6733 18.9973 63.4706 18.2933 63.0653 17.792C62.6599 17.2907 62.0946 17.04 61.3693 17.04C60.6333 17.04 60.0626 17.2907 59.6573 17.792C59.2626 18.2933 59.0653 19.008 59.0653 19.936C59.0653 20.864 59.2626 21.5787 59.6573 22.08C60.0626 22.5813 60.6333 22.832 61.3693 22.832ZM70.6873 24.112C69.8979 24.112 69.2046 23.9413 68.6073 23.6C68.0099 23.2587 67.5459 22.7733 67.2153 22.144C66.8953 21.5147 66.7353 20.7787 66.7353 19.936C66.7353 19.0933 66.8953 18.3573 67.2153 17.728C67.5459 17.088 68.0099 16.5973 68.6073 16.256C69.2046 15.9147 69.8979 15.744 70.6873 15.744C71.4659 15.744 72.1539 15.9147 72.7513 16.256C73.3486 16.5973 73.8073 17.088 74.1273 17.728C74.4579 18.3573 74.6233 19.0933 74.6233 19.936C74.6233 20.7787 74.4579 21.5147 74.1273 22.144C73.8073 22.7733 73.3486 23.2587 72.7513 23.6C72.1539 23.9413 71.4659 24.112 70.6873 24.112ZM70.6713 22.832C71.4179 22.832 71.9886 22.5867 72.3833 22.096C72.7779 21.6053 72.9753 20.8853 72.9753 19.936C72.9753 19.008 72.7726 18.2933 72.3673 17.792C71.9726 17.2907 71.4126 17.04 70.6873 17.04C69.9513 17.04 69.3806 17.2907 68.9753 17.792C68.5699 18.2933 68.3673 19.008 68.3673 19.936C68.3673 20.8853 68.5646 21.6053 68.9593 22.096C69.3646 22.5867 69.9353 22.832 70.6713 22.832ZM84.2498 24.112C83.4604 24.112 82.7671 23.9413 82.1698 23.6C81.5724 23.2587 81.1084 22.7733 80.7778 22.144C80.4578 21.5147 80.2978 20.7787 80.2978 19.936C80.2978 19.0933 80.4578 18.3573 80.7778 17.728C81.1084 17.088 81.5724 16.5973 82.1698 16.256C82.7671 15.9147 83.4604 15.744 84.2498 15.744C85.0284 15.744 85.7164 15.9147 86.3138 16.256C86.9111 16.5973 87.3698 17.088 87.6898 17.728C88.0204 18.3573 88.1858 19.0933 88.1858 19.936C88.1858 20.7787 88.0204 21.5147 87.6898 22.144C87.3698 22.7733 86.9111 23.2587 86.3138 23.6C85.7164 23.9413 85.0284 24.112 84.2498 24.112ZM84.2338 22.832C84.9804 22.832 85.5511 22.5867 85.9458 22.096C86.3404 21.6053 86.5378 20.8853 86.5378 19.936C86.5378 19.008 86.3351 18.2933 85.9298 17.792C85.5351 17.2907 84.9751 17.04 84.2498 17.04C83.5138 17.04 82.9431 17.2907 82.5378 17.792C82.1324 18.2933 81.9298 19.008 81.9298 19.936C81.9298 20.8853 82.1271 21.6053 82.5218 22.096C82.9271 22.5867 83.4978 22.832 84.2338 22.832ZM93.4514 13.52C92.566 13.52 92.1234 14.0267 92.1234 15.04V15.936H94.0114V17.184H92.1234V24H90.5074V17.184H88.9554V15.936H90.5074V14.912C90.5074 14.016 90.7314 13.3333 91.1794 12.864C91.638 12.3947 92.278 12.16 93.0994 12.16C93.526 12.16 93.9154 12.2133 94.2674 12.32V13.648C93.9794 13.5627 93.7074 13.52 93.4514 13.52ZM98.9983 13.52C98.1129 13.52 97.6703 14.0267 97.6703 15.04V15.936H99.5583V17.184H97.6703V24H96.0543V17.184H94.5023V15.936H96.0543V14.912C96.0543 14.016 96.2783 13.3333 96.7263 12.864C97.1849 12.3947 97.8249 12.16 98.6463 12.16C99.0729 12.16 99.4623 12.2133 99.8143 12.32V13.648C99.5263 13.5627 99.2543 13.52 98.9983 13.52ZM108.002 20H102.242C102.295 21.888 103.154 22.832 104.818 22.832C105.746 22.832 106.594 22.528 107.362 21.92L107.858 23.072C107.495 23.392 107.031 23.648 106.466 23.84C105.911 24.0213 105.351 24.112 104.786 24.112C103.495 24.112 102.482 23.744 101.746 23.008C101.01 22.2613 100.642 21.2427 100.642 19.952C100.642 19.1307 100.802 18.4 101.122 17.76C101.452 17.12 101.911 16.624 102.498 16.272C103.084 15.92 103.751 15.744 104.498 15.744C105.586 15.744 106.439 16.096 107.058 16.8C107.687 17.504 108.002 18.48 108.002 19.728V20ZM104.53 16.944C103.922 16.944 103.426 17.1253 103.042 17.488C102.658 17.8507 102.412 18.368 102.306 19.04H106.578C106.514 18.3573 106.306 17.84 105.954 17.488C105.602 17.1253 105.127 16.944 104.53 16.944ZM113.872 15.744C114.117 15.744 114.373 15.7813 114.64 15.856L114.608 17.328C114.32 17.2213 114.005 17.168 113.664 17.168C112.928 17.168 112.373 17.392 112 17.84C111.637 18.2773 111.456 18.832 111.456 19.504V24H109.856V18.208C109.856 17.3653 109.813 16.608 109.728 15.936H111.232L111.376 17.392C111.589 16.8587 111.92 16.4533 112.368 16.176C112.816 15.888 113.317 15.744 113.872 15.744ZM118.609 24.112C117.201 24.112 116.092 23.7707 115.281 23.088L115.761 21.92C116.604 22.56 117.569 22.88 118.657 22.88C119.212 22.88 119.633 22.7893 119.921 22.608C120.209 22.416 120.353 22.1493 120.353 21.808C120.353 21.52 120.252 21.296 120.049 21.136C119.857 20.9653 119.527 20.8213 119.057 20.704L117.713 20.384C117.009 20.2347 116.471 19.9733 116.097 19.6C115.735 19.216 115.553 18.7413 115.553 18.176C115.553 17.4507 115.841 16.864 116.417 16.416C117.004 15.968 117.777 15.744 118.737 15.744C119.313 15.744 119.857 15.8347 120.369 16.016C120.892 16.1973 121.335 16.4533 121.697 16.784L121.201 17.92C120.423 17.3013 119.601 16.992 118.737 16.992C118.215 16.992 117.809 17.0933 117.521 17.296C117.233 17.488 117.089 17.76 117.089 18.112C117.089 18.3893 117.18 18.6133 117.361 18.784C117.543 18.9547 117.831 19.088 118.225 19.184L119.601 19.52C120.369 19.6907 120.935 19.9627 121.297 20.336C121.671 20.6987 121.857 21.1733 121.857 21.76C121.857 22.4853 121.564 23.0613 120.977 23.488C120.401 23.904 119.612 24.112 118.609 24.112Z"
                fill="$primary-color"
              />
            </svg>

            <svg
              width="37"
              height="35"
              viewBox="0 0 37 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.25"
                y="0.25"
                width="36.5"
                height="34.5"
                fill="white"
                stroke="$primary-color"
                strokeWidth="0.5"
              />
              <path
                d="M9.61969 6.84332H6.06769C5.57751 6.84332 5.17969 7.24115 5.17969 7.73132V11.2833C5.17969 11.7735 5.57751 12.1713 6.06769 12.1713C6.55786 12.1713 6.95569 11.7735 6.95569 11.2833V8.61932H9.61969C10.1099 8.61932 10.5077 8.2215 10.5077 7.73132C10.5077 7.24115 10.1099 6.84332 9.61969 6.84332Z"
                fill="$primary-color"
              />
              <path
                d="M30.9314 22.828C30.4412 22.828 30.0434 23.2258 30.0434 23.716V26.38H27.3794C26.8892 26.38 26.4914 26.7778 26.4914 27.268C26.4914 27.7582 26.8892 28.156 27.3794 28.156H30.9314C31.4216 28.156 31.8194 27.7582 31.8194 27.268V23.716C31.8194 23.2258 31.4216 22.828 30.9314 22.828Z"
                fill="$primary-color"
              />
              <path
                d="M30.9314 6.84332H27.3794C26.8892 6.84332 26.4914 7.24115 26.4914 7.73132C26.4914 8.2215 26.8892 8.61932 27.3794 8.61932H30.0434V11.2833C30.0434 11.7735 30.4412 12.1713 30.9314 12.1713C31.4216 12.1713 31.8194 11.7735 31.8194 11.2833V7.73132C31.8194 7.24115 31.4216 6.84332 30.9314 6.84332Z"
                fill="$primary-color"
              />
              <path
                d="M9.61969 26.38H6.95569V23.716C6.95569 23.2258 6.55786 22.828 6.06769 22.828C5.57751 22.828 5.17969 23.2258 5.17969 23.716V27.268C5.17969 27.7582 5.57751 28.156 6.06769 28.156H9.61969C10.1099 28.156 10.5077 27.7582 10.5077 27.268C10.5077 26.7778 10.1099 26.38 9.61969 26.38Z"
                fill="$primary-color"
              />
              <path
                d="M10.5079 10.3957H8.73193V24.6037H10.5079V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M14.0601 10.3957H12.2841V21.0517H14.0601V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M17.6124 10.3957H15.8364V21.0517H17.6124V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M21.1635 10.3957H19.3875V24.6037H21.1635V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M24.7151 10.3957H22.9391V21.0517H24.7151V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M28.2674 10.3957H26.4914V24.6037H28.2674V10.3957Z"
                fill="$primary-color"
              />
              <path
                d="M14.0601 22.828H12.2841V24.604H14.0601V22.828Z"
                fill="$primary-color"
              />
              <path
                d="M17.6124 22.828H15.8364V24.604H17.6124V22.828Z"
                fill="$primary-color"
              />
              <path
                d="M24.7151 22.828H22.9391V24.604H24.7151V22.828Z"
                fill="$primary-color"
              />
            </svg>

            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.25"
                y="0.25"
                width="34.5"
                height="34.5"
                fill="white"
                stroke="$primary-color"
                strokeWidth="0.5"
              />
              <path
                d="M17.7803 23.1552L15.1553 25.7802C14.8628 26.0731 14.3873 26.0731 14.0948 25.7802L11.4698 23.1552C11.177 22.8623 11.177 22.3876 11.4698 22.0947C11.7623 21.8018 12.2378 21.8018 12.5303 22.0947L13.8751 23.4395V8.74997C13.8751 8.33597 14.2111 7.99997 14.6251 7.99997C15.0391 7.99997 15.3751 8.33597 15.3751 8.74997V23.4395L16.7198 22.0947C16.8661 21.9481 17.0581 21.875 17.2501 21.875C17.4421 21.875 17.6341 21.9481 17.7803 22.0947C18.0732 22.3876 18.0732 22.8623 17.7803 23.1552Z"
                fill="$primary-color"
              />
              <path
                d="M24.5303 11.9053C24.2374 12.1981 23.7626 12.1981 23.4698 11.9053L22.125 10.5605V25.25C22.125 25.664 21.789 26 21.375 26C20.961 26 20.625 25.664 20.625 25.25V10.5605L19.2803 11.9053C18.9874 12.1981 18.5123 12.1981 18.2198 11.9053C17.9269 11.6124 17.9269 11.1376 18.2198 10.8447L20.8448 8.21975C20.9914 8.07312 21.183 8 21.375 8C21.567 8 21.7586 8.07312 21.9053 8.21975L24.5303 10.8447C24.8231 11.1376 24.8231 11.6124 24.5303 11.9053Z"
                fill="$primary-color"
              />
            </svg>

            <svg
              width="35"
              height="35"
              viewBox="0 0 35 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.25"
                y="0.25"
                width="34.5"
                height="34.5"
                fill="white"
                stroke="$primary-color"
                strokeWidth="0.5"
              />
              <path
                d="M28 9H8L16 18.46V25L20 27V18.46L28 9Z"
                stroke="$primary-color"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div> */}
        </div>
        <div className={`${!newMenu && "col-12"} m-0 p-3 treatment-menu`}>
          {!newMenu ? (
            <>
              <div className="row">
                {menuItems.length > 0
                  ? menuItems.map((data, index) => {
                      return (
                        <div className=" fs-13 ml-2 mb-2 py-2" key={index}>
                          <div
                            className={`menus p-1 rounded ${
                              activeMenu === data.id ? "active" : ""
                            }`}
                            onClick={() => this.handleMenu(data.id, data.label)}
                          >
                            {t(String(data.label).toUpperCase())}
                          </div>
                        </div>
                      );
                    })
                  : ""}
              </div>

              <div className="row py-2">
                <div className="input-group col-4 pl-2 range-filter">
                  <NormalSelect
                    // placeholder="Enter here"
                    options={menuOption}
                    value={menuId}
                    name={"menuId"}
                    onChange={this.handleMenuChange}
                    className="py-0"
                  />
                </div>
                {activeMenu && activeMenu !== 8 && activeMenu !== 9 ? (
                  <div className="input-group col-4 range-filter">
                    <NormalSelect
                      // placeholder="Enter here"
                      options={rangeOption}
                      value={rangeId}
                      name={"rangeId"}
                      onChange={this.handleRangeChange}
                      className="py-0"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            <div className="row">
              {/* top New menus start */}
              {/* {console.log("dsfgsdfgdfgdfgsdf", currentMenus)} */}

              {prevMenus?.length > 0 ? (
                // <div className="col-md-4 col-12 fs-12 p-1">
                <div
                  // className={`${
                  //   deviceWidth > 1280
                  //     ? "col-3"
                  //     : deviceWidth < 400
                  //     ? "col-6"
                  //     : "col-4"
                  // } fs-12 p-1`}
                  className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fs-12 p-1"
                >
                  <div
                    className={`menus`}
                    //style={{ width: "50px" }}
                    // onClick={() => this.handleMenu(data.id, data.label)}
                    onClick={() => this.handleGoPrev()}
                  >
                    <img src={back} alt="" width="20" /> Prev
                  </div>
                </div>
              ) : (
                ""
              )}

              {currentMenus?.length > 0
                ? currentMenus.map((data, index) => {
                    return (
                      // <div className="col-md-4 col-12 fs-10 p-1" key={index}>
                      <div
                        // className={`${
                        //   deviceWidth > 1280
                        //     ? "col-3"
                        //     : deviceWidth < 400
                        //     ? "col-6"
                        //     : "col-4 col-sm-6"
                        // } fs-12 p-1`}
                        className="col-6 col-sm-3 col-md-4 col-lg-3 col-xl-3 fs-12 p-1"
                        key={index}
                      >
                        <div
                          className={`menus ${
                            activeMenu === data.menuCode ? "active" : ""
                          }`}
                          style={{
                            backgroundColor:
                              activeMenu === data.menuCode
                                ? "#e29eda"
                                : data.bgcolor || "#d5f7d5",
                            color:
                              activeMenu === data.menuCode ? "white" : "black",
                          }}
                          // onClick={() => this.handleMenu(data.id, data.label)}
                          onClick={() => this.handleMenuClick(data)}
                        >
                          <div className="menuCircleImg">
                            <img
                              src={
                                data.img ||
                                "https://media.istockphoto.com/id/921797424/photo/woman-in-mask-on-face-in-spa-beauty-salon.jpg?s=612x612&w=0&k=20&c=gGSPZOjIS2wcwQyOcjANOKpRVU0KR_iEDbRACnAoIXA="
                              }
                              alt="productImg"
                              className="menuImg"
                            />
                          </div>

                          <div className="menuTiteMainWidth">
                            <h6
                              className="menuTitle"
                              style={{
                                color:
                                  activeMenu === data.menuCode
                                    ? "white"
                                    : "black",
                              }}
                            >
                              {data &&
                              Array.isArray(data?.child) &&
                              data.child.length > 0 ? (
                                <span className="submenuCircle"></span>
                              ) : (
                                ""
                              )}{" "}
                              {t(data.menuDescription)}
                            </h6>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : ""}

              {/* top New menus end */}
            </div>
          )}
        </div>
        {activeTab === "treatment" ? (
          <div className="services m-0 row">
            {/* service - 3 (item_type: "SINGLE"), package - 3 (item_type: "PACKAGE") , retail - 1 , prepaid -5, voucher - 4 */}
            {dataList.length > 0
              ? dataList.map((data, index) => {
                  return (
                    <div
                      // className="col-md-6 col-lg-4 col-xl-3  fs-12 p-2 viewcard"
                      // className={`${
                      //   deviceWidth > 1280
                      //     ? "col-3"
                      //     : deviceWidth < 400
                      //     ? "col-6"
                      //     : "col-4 col-sm-6"
                      // } fs-12 p-2 viewcard`}
                      className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 fs-12 p-2 viewcard"
                      key={data.id}
                    >
                      <div className="service-tab p-0">
                        <div className="service-ttl px-2 fw-600 ">
                          {data.item_desc}
                        </div>

                        <div className="price ">
                          {/* image*/}
                          {data.item_div === "1" ||
                          (data.item_div == "3" &&
                            String(data.item_type).toUpperCase() ===
                              "SINGLE") ? (
                            <div
                              style={{
                                backgroundColor: this.state.bgcolor,
                                //opacity: "0.6",
                              }}
                              className={`imagesretail cursor-pointer`}
                              onClick={() =>
                                this.handleSelectPrice(data, index)
                              }
                            >
                              <img
                                src={data.Stock_PIC}
                                alt=""
                                style={{ objectFit: "cover" }}
                              />{" "}
                            </div>
                          ) : (
                            <div
                              className="images cursor-pointer"
                              style={{
                                backgroundColor: this.state.bgcolor,
                                //opacity: "0.6",
                              }}
                              onClick={() => this.handleAddCart(data)}
                            >
                              <img
                                src={data.Stock_PIC}
                                alt=""
                                style={{ objectFit: "cover" }}
                              />
                            </div>
                          )}
                          {/* SVG*/}

                          <div className="non-retail">
                            {/*  Update 75 with the Duration dept id   */}
                            {data?.is_duration_product === 1 ||
                            (data.item_div === "3" &&
                              String(data.item_type).toUpperCase() ===
                                "PACKAGE") ||
                            data.item_div === "5" ? null : (
                              <span
                                className={`${
                                  (data.item_div === "3" &&
                                    String(data.item_type).toUpperCase() ===
                                      "SINGLE") ||
                                  data.item_div === "5"
                                    ? `foc-icon`
                                    : `foc-icon-re`
                                }`}
                                onClick={() => this.handleFocImageClick(data)}
                              >
                                <svg
                                  width="49"
                                  height="32"
                                  className="cursor-pointer"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="4"
                                    y="5"
                                    width="45"
                                    height="20"
                                    stroke="#000"
                                    fill="#fff"
                                  />
                                  <text x="14" y="19.5" fill="red">
                                    {t("FOC")}
                                  </text>
                                </svg>
                              </span>
                            )}
                            {/*  Update 75 with the Duration dept id   */}
                            {data?.is_duration_product ===
                            1 ? null : data.item_div === "3" &&
                              String(data.item_type).toUpperCase() ===
                                "SINGLE" ? (
                              <span
                                className="cc"
                                onClick={() =>
                                  this.handleServiceItemCourse(data)
                                }
                              >
                                <svg
                                  width="49"
                                  height="32"
                                  className="cursor-pointer"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="4"
                                    y="5"
                                    width="45"
                                    height="20"
                                    stroke="green"
                                    fill="#fff"
                                  />
                                  <text x="22.5" y="19.5" fill="#000">
                                    {t("C")}
                                  </text>
                                </svg>
                              </span>
                            ) : (
                              <>
                                {(data.item_div === "5" ||
                                  data.item_div === "3") &&
                                  data?.is_open_prepaid === true && (
                                    <span
                                      onClick={() =>
                                        this.handleOpenPrepaidClick(data)
                                      }
                                    >
                                      <svg
                                        width="49"
                                        height="32"
                                        className="cursor-pointer"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          x="4"
                                          y="5"
                                          width="45"
                                          height="20"
                                          stroke="#3C4087"
                                          fill="#fff"
                                        />
                                        <text x="18" y="19" fill="#3C4087">
                                          {t("OP")}
                                        </text>
                                      </svg>
                                    </span>
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                        {/*rate*/}
                        <div className="button">
                          <NormalButtonCart
                            buttonClass={"detail-button mt-1"}
                            // mainbg={true}
                            className="col-12 fs-15 "
                            label={
                              (data.item_div === "3" &&
                                String(data.item_type).toUpperCase() ===
                                  "SINGLE") ||
                              data.item_div === "5" ? (
                                <>
                                  <span className="fw-600 btnlabel"> </span>
                                  <span className="fw-600 btnlabel">
                                    {data.item_price
                                      ? Number(data.item_price).toFixed(2)
                                      : ""}
                                  </span>
                                </>
                              ) : data.item_div === "1" ? (
                                <span className="fw-600 btnlabel">
                                  {" "}
                                  {data.uomprice.length > 0
                                    ? Number(
                                        data.uomprice[0].item_price
                                      ).toFixed(2)
                                    : ""}
                                </span>
                              ) : (
                                <span className="fw-600 btnlabel">
                                  {" "}
                                  {data.item_price
                                    ? Number(data.item_price).toFixed(2)
                                    : ""}
                                </span>
                              )
                            }
                            outline={true}
                            onClick={() => {
                              if (data?.is_duration_product === 1) {
                                this.handleSelectPrice(data, index);
                              } else {
                                this.handleSubmit(data, index);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
              : ""}

            {pagination && (
              <Pagination
                handlePagination={this.handlePagination}
                pageMeta={pagination}
              />
            )}
          </div>
        ) : (
          ""
        )}

        {activeTab === "treatmentDetail" ? (
          <div className="services m-0 row">
            <div className="col-12">
              <p>
                <span
                  className={"curser-pointer fw-700"}
                  onClick={() => this.setState({ activeTab: "treatment" })}
                >
                  {activeMenuName !== "" ? t(activeMenuName) : ""}
                </span>{" "}
                <span>{rangeName !== "" ? " > " + rangeName : ""}</span> {">"}{" "}
                <span>{serviceName ? serviceName : ""}</span>
              </p>
            </div>
            <div className="row m-4">
              <div className="col-12 col-md-6">
                <img src={serviceDetail.Stock_PIC} alt="" width="200"></img>
              </div>
              <div className="col-12 col-md-6">
                <p className="healine fs-18">{serviceDetail.item_desc}</p>
                <p className="description fs-16 my-2">
                  {serviceDetail.item_name}
                </p>
                <p>
                  {serviceDetail.item_div === "3" &&
                  String(serviceDetail.item_type).toUpperCase() === "SINGLE" ? (
                    <span
                      className="foc-icon pr-3"
                      onClick={() =>
                        this.handleServiceItemCourse(serviceDetail)
                      }
                    >
                      <svg
                        width="32"
                        height="32"
                        className="cursor-pointer"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="15.5"
                          fill="white"
                          stroke="#023F88"
                        />
                        <text
                          x="11"
                          y="21"
                          fill="#023F88"
                          className="text-uppercase"
                        >
                          {t("C")}
                        </text>
                      </svg>
                    </span>
                  ) : null}
                  {(serviceDetail.item_div === "5" ||
                    serviceDetail.item_div === "3") &&
                  serviceDetail?.is_open_prepaid === true ? (
                    <span
                      className="foc-icon pr-3"
                      onClick={() => this.handleOpenPrepaidClick(serviceDetail)}
                    >
                      <svg
                        width="32"
                        height="32"
                        className="cursor-pointer"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="15.5"
                          fill="white"
                          stroke="#023F88"
                        />
                        <text x="5" y="21" fill="#023F88">
                          {t("OP")}
                        </text>
                      </svg>
                    </span>
                  ) : null}
                  {(serviceDetail.item_div === "3" &&
                    String(serviceDetail.item_type).toUpperCase() ===
                      "PACKAGE") ||
                  serviceDetail.item_div === "5" ? null : (
                    <svg
                      onClick={() => this.handleFocImageClick(serviceDetail)}
                      width="32"
                      height="32"
                      className="cursor-pointer"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="16"
                        cy="16"
                        r="15.5"
                        fill="white"
                        stroke="#023F88"
                      />
                      <path
                        d="M3.996 11.456H9.42V12.476H5.22V15.152H9.18V16.172H5.22V20H3.996V11.456ZM14.3243 20.096C13.5163 20.096 12.8123 19.92 12.2123 19.568C11.6203 19.208 11.1603 18.7 10.8323 18.044C10.5123 17.388 10.3523 16.616 10.3523 15.728C10.3523 14.832 10.5123 14.056 10.8323 13.4C11.1523 12.744 11.6123 12.24 12.2123 11.888C12.8123 11.536 13.5163 11.36 14.3243 11.36C15.1403 11.36 15.8443 11.536 16.4362 11.888C17.0363 12.24 17.4963 12.744 17.8163 13.4C18.1363 14.056 18.2963 14.828 18.2963 15.716C18.2963 16.612 18.1363 17.388 17.8163 18.044C17.4963 18.7 17.0363 19.208 16.4362 19.568C15.8363 19.92 15.1323 20.096 14.3243 20.096ZM14.3243 19.088C15.1803 19.088 15.8443 18.796 16.3163 18.212C16.7963 17.628 17.0363 16.796 17.0363 15.716C17.0363 14.644 16.7963 13.82 16.3163 13.244C15.8443 12.66 15.1803 12.368 14.3243 12.368C13.4683 12.368 12.8043 12.66 12.3323 13.244C11.8603 13.82 11.6243 14.644 11.6243 15.716C11.6243 16.796 11.8603 17.628 12.3323 18.212C12.8123 18.796 13.4763 19.088 14.3243 19.088ZM23.7598 20.096C22.9358 20.096 22.2158 19.92 21.5998 19.568C20.9918 19.208 20.5238 18.7 20.1958 18.044C19.8678 17.388 19.7038 16.612 19.7038 15.716C19.7038 14.828 19.8678 14.056 20.1958 13.4C20.5238 12.744 20.9918 12.24 21.5998 11.888C22.2158 11.536 22.9358 11.36 23.7598 11.36C24.3438 11.36 24.8838 11.452 25.3798 11.636C25.8838 11.812 26.3078 12.072 26.6518 12.416L26.2198 13.328C25.8198 13 25.4238 12.764 25.0318 12.62C24.6478 12.468 24.2278 12.392 23.7718 12.392C22.8838 12.392 22.1958 12.68 21.7078 13.256C21.2278 13.832 20.9878 14.652 20.9878 15.716C20.9878 16.788 21.2278 17.616 21.7078 18.2C22.1958 18.776 22.8838 19.064 23.7718 19.064C24.2278 19.064 24.6478 18.992 25.0318 18.848C25.4238 18.696 25.8198 18.456 26.2198 18.128L26.6518 19.04C26.3078 19.384 25.8838 19.648 25.3798 19.832C24.8838 20.008 24.3438 20.096 23.7598 20.096Z"
                        fill="#023F88"
                      />
                    </svg>
                  )}
                </p>
                <p className="healine my-2">
                  <span>{t("Price")} :</span>
                  <span> {serviceDetail.item_price}</span>
                </p>
              </div>
            </div>

            <div className="col-md-12 col-12 justify-content-center align-self-center text-center select-treatment py-2">
              <NormalButton
                mainbg={false}
                className="col-12 fs-15 submit-btn w-100"
                label="Add to Cart"
                onClick={
                  // activeMenu === "RETAIL"
                  //   ? () => this.setState({ isOpenPriceModal: true })
                  //   : () => this.handleAddCart(serviceDetail)

                  serviceDetail.item_div === "1"
                    ? () => this.setState({ isOpenPriceModal: true })
                    : serviceDetail.item_div === "3" &&
                      String(serviceDetail.item_type).toUpperCase() === "SINGLE"
                    ? () => this.setState({ isServicePopModal: true })
                    : () => this.handleDetailAddCartClick(serviceDetail)
                }
              />
            </div>

            <div className="col-12">
              {itemDescription.length > 0 ? (
                <div className="d-flex h6">{t("Item description")}</div>
              ) : (
                ""
              )}
              {itemDescription.length > 0
                ? itemDescription.map((data, index) => {
                    return (
                      <div className="d-flex fs-15" key={index}>
                        <div className="col-1 text-right">{data.line_no}</div>
                        <div className="col-11 text-left">
                          {data.protocol_detail}
                        </div>
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        ) : null}

        {/* Retail Model */}
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "1020px" }}
          modal={this.state.isOpenPriceModal}
          handleModal={this.handleCloseDialog}
        >
          <img
            onClick={this.handleCloseDialog}
            className="close"
            src={closeIcon}
            alt=""
          />

          <div className=" mt-2 mb-5 mx-3">
            <div className="col-12 pl-0 mb-3 fs-18 py-2">
              {t("Select Product UOM For")} {serviceDetail.item_name}
            </div>
            <div className="row title fs-15 mb-2 fw-600">
              <div className="col-md-1">{t("S.No")}</div>
              <div className="col-md-1">{t("IOH")}</div>
              <div className="col-md-1">{t("UOM")}</div>
              <div className="col-md-1">{t("Price")}</div>
              <div className="col-md-1">{t("Qty")}</div>
              <div className="col-md-1">
                {t("Hold")}
                {t("Qty")}
              </div>
              {this.state.holdCheckbox && (
                <div className="col-md-2">{t("HoldReason")}</div>
              )}
              {this.state.focCheckbox && (
                <div className="col-md-2">{t("FOC Reason")}</div>
              )}
              {this.props.tokenDetails.retailbatchsno && (
                <div className="col-md-4">{t("Item Serial Number")}</div>
              )}
              <div className="col-md-1"></div>
            </div>

            {serviceDetail.uomprice && serviceDetail.uomprice.length > 0
              ? serviceDetail.uomprice.map((data, index) => {
                  return (
                    <div className="row mb-1 fs-14" key={index}>
                      <div className="col-1">{index + 1}</div>
                      <div className="col-1">{data.onhand_qty}</div>
                      <div className="col-1 text-left">{data.itemuom_desc}</div>
                      <div className="col-1">{data.item_price}</div>
                      <div className="col-1">
                        {this.props.tokenDetails.ipadkey ? (
                          <NumPadKeyboard
                            onChange={(val) =>
                              this.handleQtyChange(val, "formQty", index)
                            }
                            value={data.formQty ? data.formQty : Number(1)} //default value 1set for qty
                            decimal={false}
                          />
                        ) : (
                          <NormalInput
                            type="number"
                            value={data.formQty ? data.formQty : Number(1)} //default value 1set for qty
                            onChange={(e) =>
                              this.handleQtyChange(
                                e.target.value,
                                "formQty",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`formQty`}
                            disabled={
                              tokenDetails?.retailbatchsno && data?.serial_no
                                ? true
                                : false
                            }
                          />
                        )}
                      </div>
                      <div className="col-1">
                        {this.props.tokenDetails.ipadkey ? (
                          <NumPadKeyboard
                            onChange={(val) =>
                              this.handleHoldQtyChange(
                                val,
                                "formHoldQty",
                                index
                              )
                            }
                            value={data.formHoldQty ? data.formHoldQty : ""}
                            decimal={false}
                            // sync={true}
                          />
                        ) : (
                          <NormalInput
                            type="number"
                            value={data.formHoldQty ? data.formHoldQty : ""}
                            onChange={(e) =>
                              this.handleHoldQtyChange(
                                e.target.value,
                                "formHoldQty",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`formHoldQty`}
                          />
                        )}
                      </div>

                      {this.state.holdCheckbox && (
                        <div className="col-md-2">
                          <NormalSelect
                            // placeholder="Enter here"
                            options={holdReasonList}
                            value={
                              data.holdSelectedReason
                                ? data.holdSelectedReason
                                : ""
                            }
                            name="holdSelectedReason"
                            onChange={(e) =>
                              this.handleHoldDropdownChange(e, index)
                            }
                            className="customer-name py-0"
                          />
                        </div>
                      )}

                      {this.state.focCheckbox && (
                        <div className="col-md-2">
                          <NormalSelect
                            // placeholder="Enter here"
                            options={focReasonList}
                            value={
                              data.focSelectedReason
                                ? data.focSelectedReason
                                : ""
                            }
                            name="focSelectedReason"
                            onChange={(e) =>
                              this.handleFOCDropdownChange(e, index)
                            }
                            className="customer-name py-0"
                          />
                        </div>
                      )}
                      {this.props.tokenDetails.retailbatchsno && (
                        <div className="col-md-3">
                          <NormalInput
                            type="text"
                            value={data.verify_serial}
                            onChange={(e) =>
                              this.handleBatchNoChange(
                                e.target.value,
                                "verify_serial",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`verify_serial`}
                          />
                        </div>
                      )}

                      {!this.state.focCheckbox && (
                        <NormalButton
                          buttonClass={"col-md-2 detail-button addtocart mr-3"}
                          mainbg={true}
                          className="col-12 fs-15 "
                          label="Cart"
                          onClick={() =>
                            this.handleBeforeAddCart(
                              serviceDetail,
                              data.item_price,
                              data.itemuom_id,
                              Number(data.formQty),
                              index
                            )
                          }
                        />
                      )}
                      {this.state.focCheckbox && (
                        <NormalButton
                          buttonClass={"col-md-1 detail-button addtocart mr-3"}
                          mainbg={true}
                          className="col-12 fs-15 "
                          label="Cart"
                          onClick={() =>
                            this.handleBeforeAddFOC(
                              serviceDetail,
                              data.item_price,
                              data.itemuom_id,
                              Number(data.formQty),
                              index
                            )
                          }
                        />
                      )}
                    </div>
                  );
                })
              : null}
          </div>
        </NormalModal>
        {/* Service Model */}

        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "1020px" }}
          modal={isServicePopModal}
          handleModal={this.handleServicePopCloseDialog}
        >
          <img
            onClick={this.handleServicePopCloseDialog}
            className="close"
            src={closeIcon}
            alt=""
          />

          <div className=" mt-2 mb-5 mx-3">
            <div className="col-12 pl-0 mb-3 fs-18 py-2">
              {serviceDetail.item_name}
            </div>
            <div className="row title fs-16 mb-2 f-600">
              <div className="col-2">{t("Price")}</div>
              <div className="col-2">{t("Qty")}</div>
              {this.state.focCheckbox && (
                <div className="col-2">{t("FOC Reason")}</div>
              )}
            </div>

            <div className="row mb-1 fs-14">
              <div className="col-2">{serviceDetail.item_price}</div>
              <div className="col-2">
                <NormalInput
                  type="number"
                  value={this.state.formQty}
                  onChange={(e) =>
                    this.handleQtyChange(e.target.value, "", "-1")
                  }
                />
              </div>

              {this.state.focCheckbox && (
                <div className="col-sm-3">
                  <NormalSelect
                    // placeholder="Enter here"
                    options={focReasonList}
                    value={this.state.focSelectedReason}
                    name="focreason"
                    onChange={(e) => this.handleFOCDropdownChange(e, "-1")}
                    className="customer-name py-0"
                  />
                </div>
              )}

              <div className="col-3 d-flex">
                <NormalButton
                  // buttonClass={"detail-button addtocart mr-3"}
                  mainbg={true}
                  className="col-12 px-4 fs-15 "
                  label="Cart"
                  onClick={() =>
                    this.handleAddCart(
                      serviceDetail,
                      serviceDetail.item_price,
                      0,
                      Number(this.state.formQty)
                    )
                  }
                />
              </div>
            </div>
          </div>
        </NormalModal>

        {/* Duration Model */}
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "1020px" }}
          modal={isOpenDuration}
          handleModal={this.handleCloseDuration}
        >
          <img
            onClick={this.handleCloseDuration}
            className="close"
            src={closeIcon}
            alt=""
          />

          <div className=" mt-2 mb-5 mx-3">
            <div className="col-12 pl-0 mb-3 fs-18 py-2">
              {t("Select Total Duration For")} {serviceDetail.item_name}
            </div>

            <div className="d-flex justify-content-around">
              <div className="d-flex align-items-center col-3 ">
                <p className="col-4 ">Hour</p>
                <div className="col-8">
                  <NormalInput
                    type="text"
                    value={hours}
                    onChange={this.handleHoursChange}
                    className="w-100"
                  />
                </div>
              </div>
              <div className="d-flex align-items-center col-3">
                <p className="col-4">Minutes</p>
                <div className="col-8">
                  <NormalInput
                    type="text"
                    value={minutes}
                    onChange={this.handleMinutesChange}
                    className="w-100"
                  />
                </div>
              </div>
              <div className="d-flex align-items-center col-3">
                <p className="col-4">Total</p>
                <div className="col-8">
                  <NormalInput
                    type="text"
                    value={total}
                    onChange={this.handleTotalChange}
                    className="w-100"
                  />
                </div>
              </div>
              <div className="col-3 d-flex">
                <NormalButton
                  // buttonClass={"detail-button addtocart mr-3"}
                  mainbg={true}
                  className="col-12 px-4 fs-15 "
                  label="Cart"
                  onClick={() =>
                    this.handleAddCart(
                      serviceDetail,
                      serviceDetail.item_price,
                      0,
                      Number(this.state.formQty)
                    )
                  }
                />
              </div>
            </div>

            {/* <div className="row title fs-15 mb-2 fw-600">
              <div className="col-md-1">{t("S.No")}</div>
              <div className="col-md-1">{t("IOH")}</div>
              <div className="col-md-1">{t("UOM")}</div>
              <div className="col-md-1">{t("Price")}</div>
              <div className="col-md-1">{t("Qty")}</div>
              <div className="col-md-1">
                {t("Hold")}
                {t("Qty")}
              </div>
              {this.state.holdCheckbox && (
                <div className="col-md-2">{t("HoldReason")}</div>
              )}
              {this.state.focCheckbox && (
                <div className="col-md-2">{t("FOC Reason")}</div>
              )}
              {this.props.tokenDetails.retailbatchsno && (
                <div className="col-md-4">{t("Item Serial Number")}</div>
              )}
              <div className="col-md-1"></div>
            </div>

            {serviceDetail.uomprice && serviceDetail.uomprice.length > 0
              ? serviceDetail.uomprice.map((data, index) => {
                  return (
                    <div className="row mb-1 fs-14" key={index}>
                      <div className="col-1">{index + 1}</div>
                      <div className="col-1">{data.onhand_qty}</div>
                      <div className="col-1 text-left">{data.itemuom_desc}</div>
                      <div className="col-1">{data.item_price}</div>
                      <div className="col-1">
                        {this.props.tokenDetails.ipadkey ? (
                          <NumPadKeyboard
                            onChange={(val) =>
                              this.handleQtyChange(val, "formQty", index)
                            }
                            value={data.formQty ? data.formQty : Number(1)} //default value 1set for qty
                            decimal={false}
                          />
                        ) : (
                          <NormalInput
                            type="number"
                            value={data.formQty ? data.formQty : Number(1)} //default value 1set for qty
                            onChange={(e) =>
                              this.handleQtyChange(
                                e.target.value,
                                "formQty",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`formQty`}
                            disabled={
                              tokenDetails?.retailbatchsno && data?.serial_no
                                ? true
                                : false
                            }
                          />
                        )}
                      </div>
                      <div className="col-1">
                        {this.props.tokenDetails.ipadkey ? (
                          <NumPadKeyboard
                            onChange={(val) =>
                              this.handleHoldQtyChange(
                                val,
                                "formHoldQty",
                                index
                              )
                            }
                            value={data.formHoldQty ? data.formHoldQty : ""}
                            decimal={false}
                            // sync={true}
                          />
                        ) : (
                          <NormalInput
                            type="number"
                            value={data.formHoldQty ? data.formHoldQty : ""}
                            onChange={(e) =>
                              this.handleHoldQtyChange(
                                e.target.value,
                                "formHoldQty",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`formHoldQty`}
                          />
                        )}
                      </div>

                      {this.state.holdCheckbox && (
                        <div className="col-md-2">
                          <NormalSelect
                            // placeholder="Enter here"
                            options={holdReasonList}
                            value={
                              data.holdSelectedReason
                                ? data.holdSelectedReason
                                : ""
                            }
                            name="holdSelectedReason"
                            onChange={(e) =>
                              this.handleHoldDropdownChange(e, index)
                            }
                            className="customer-name py-0"
                          />
                        </div>
                      )}

                      {this.state.focCheckbox && (
                        <div className="col-md-2">
                          <NormalSelect
                            // placeholder="Enter here"
                            options={focReasonList}
                            value={
                              data.focSelectedReason
                                ? data.focSelectedReason
                                : ""
                            }
                            name="focSelectedReason"
                            onChange={(e) =>
                              this.handleFOCDropdownChange(e, index)
                            }
                            className="customer-name py-0"
                          />
                        </div>
                      )}
                      {this.props.tokenDetails.retailbatchsno && (
                        <div className="col-md-3">
                          <NormalInput
                            type="text"
                            value={data.verify_serial}
                            onChange={(e) =>
                              this.handleBatchNoChange(
                                e.target.value,
                                "verify_serial",
                                index
                              )
                            }
                            className="col-12 p-1"
                            name={`verify_serial`}
                          />
                        </div>
                      )}

                      {!this.state.focCheckbox && (
                        <NormalButton
                          buttonClass={"col-md-2 detail-button addtocart mr-3"}
                          mainbg={true}
                          className="col-12 fs-15 "
                          label="Cart"
                          onClick={() =>
                            this.handleBeforeAddCart(
                              serviceDetail,
                              data.item_price,
                              data.itemuom_id,
                              Number(data.formQty),
                              index
                            )
                          }
                        />
                      )}
                      {this.state.focCheckbox && (
                        <NormalButton
                          buttonClass={"col-md-1 detail-button addtocart mr-3"}
                          mainbg={true}
                          className="col-12 fs-15 "
                          label="Cart"
                          onClick={() =>
                            this.handleBeforeAddFOC(
                              serviceDetail,
                              data.item_price,
                              data.itemuom_id,
                              Number(data.formQty),
                              index
                            )
                          }
                        />
                      )}
                    </div>
                  );
                })
              : null} */}
          </div>
        </NormalModal>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "30%" }}
          modal={isTcm}
          handleModal={this.handleCloseTcm}
        >
          <img
            onClick={this.handleCloseTcm}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <div>
            <p>中药</p>
            <div className="d-flex flex-column col-12 col-xl-12 col-lg-12 mt-3">
              <div className="d-flex align-items-center">
                <div className="col-lg-4 col-xl-4 col-sm-4 col-md-4">
                  <p>受伤部位 : </p>(医师):
                </div>
                <div className="col-lg-8 col-md-8 col-xl-8 col-sm-8">
                  <NormalMultiSelect
                    handleMultiSelect={this.handleMultiSelectInjury}
                    options={injuryOptions}
                    value={this.state.injuries}
                    name="injury"
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mt-2">
                <div className="col-lg-4 col-xl-4 col-sm-4 col-md-4">
                  <p>其他部位 : </p>
                </div>
                <div className="col-lg-8 col-md-8 col-xl-8 col-sm-8">
                  <NormalInput
                    type="text"
                    value={otherInjury}
                    onChange={(e) =>
                      this.setState({
                        otherInjury: e.target.value,
                      })
                    }
                    // className="col-12 p-1"
                    name={`verify_serial`}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mt-2">
                <div className="col-lg-4 col-xl-4 col-sm-4 col-md-4">
                  <p>受伤期 : </p>
                </div>
                <div className="col-lg-8 col-md-8 col-xl-8 col-sm-8">
                  <NormalInput
                    type="text"
                    value={injuryPeriod}
                    onChange={(e) =>
                      this.setState({
                        injuryPeriod: e.target.value,
                      })
                    }
                    // className="col-12 p-1"
                    name={`injuryPeriod`}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mt-2">
                <div className="col-lg-4 col-xl-4 col-sm-4 col-md-4">
                  <p>症状 : </p>
                </div>
                <div className="col-lg-8 col-md-8 col-xl-8 col-sm-8">
                  <NormalTextarea
                    type="text"
                    value={symptom}
                    onChange={(e) =>
                      this.setState({
                        symptom: e.target.value,
                      })
                    }
                    // className="col-12 p-1"
                    name={`symptom`}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mt-2">
                <div className="col-lg-4 col-xl-4 col-sm-4 col-md-4">
                  <p>医师 : </p>
                </div>
                <div className="col-lg-8 col-md-8 col-xl-8 col-sm-8">
                  <NormalSelect
                    onChange={this.handleInputChange}
                    options={physicianOptions}
                    value={physician}
                    name="physician"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center mt-4">
                <NormalButton
                  mainbg={true}
                  className="confirm"
                  outline={false}
                  label="Save"
                  onClick={this.handleTcmSave}
                />
              </div>
            </div>
          </div>
        </NormalModal>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "50%" }}
          modal={isVoucherActive}
          handleModal={this.handleVoucherCloseModal}
        >
          <img
            onClick={this.handleVoucherCloseModal}
            className="close"
            src={closeIcon}
            alt=""
          />

          <div className=" mt-2 mb-5 mx-3">
            <p className="fs-18 fw-700">
              Voucher Activation : {previousVoucher?.item_desc}
            </p>
            <div className="col-md-12 my-2">
              <>
                <div className="d-flex align-items-center">
                  <div className="col-md-7">
                    <p className="text-black common-label-text">
                      {t("Voucher Numbers")}
                    </p>
                    <NormalInput
                      value={voucherNumbers}
                      name="voucherNumbers"
                      onChange={this.handleVoucherNumberChange}
                    />
                  </div>
                  <div className="col-md-2 mt-4">
                    <NormalButton
                      mainbgrev={true}
                      className="col-12 "
                      label="SEARCH"
                      onClick={() => this.handleVoucherNumbers()}
                    />
                  </div>
                </div>
                <div className="my-3 d-flex justify-content-between">
                  <div>
                    <p>
                      {" "}
                      Number of Active Vouchers :{" "}
                      <strong>{totalActiveVouchers}</strong>
                    </p>
                  </div>
                  <div>
                    <p>
                      Total Amount : <strong>{totalVoucherAmount}</strong>
                    </p>
                  </div>
                </div>
                <TableWrapper headerDetails={headerDetails}>
                  {newVoucherData?.length > 0 ? (
                    newVoucherData.map((selectedVoucher, index) => (
                      <tr key={index} style={{ cursor: "pointer" }}>
                        <td>{selectedVoucher.voucher_code}</td>
                        <td>{selectedVoucher.voucher_description}</td>
                        <td>{selectedVoucher.voucher_value}</td>
                        <td>{selectedVoucher.expiry_date}</td>
                        <td>{selectedVoucher.discount}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        No Data
                      </td>
                    </tr>
                  )}
                </TableWrapper>
                <div className="mt-3 d-flex justify-content-end">
                  <NormalButton
                    mainbg={false}
                    className="col-12 fs-15 submit-btn w-100"
                    label="Confirm"
                    onClick={this.handleSubmitVoucher}
                  />
                </div>
              </>
            </div>
          </div>
        </NormalModal>
        {/* Open Package */}
        <NormalModal
          className={"package-modal"}
          style={{ minWidth: "75%" }}
          modal={isOpenPackagePopup}
          handleModal={this.handleOpenPackageDialog}
        >
          <img
            onClick={this.handleOpenPackageDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <OpenPackage
            originalPackage={this.state.packageData}
            handleModal={this.handleOpenPackageDialog}
            handleAddCart={this.handleAddCart}
            loaderVisible={this.state.isLoading}
            cartData={this.props.cartData}
          ></OpenPackage>
        </NormalModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selected_cstomer: state.common.selected_cstomer,
  // basicApptDetail: state.appointment.basicApptDetail,
  selectedCart: state.common.selectedCart,
  tokenDetails: state.authStore.tokenDetails,
  getDiscount: state.common.isDiscount,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      commonUpdateApi,
      updateDiscount,
    },
    dispatch
  );
};

export const Treatment = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TreatmentClass)
);